import Footer from '../components/Footer/Footer';
import Copilot from '../Copilot/Copilot'; /* eslint-disable */
import React from 'react';
import { transformProxies } from './helpers';

const scripts = [
  {
    loading: Promise.resolve(
      '($=jQuery)(document).ready(function(){$(".billing-option").click(function(){$(".billing-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".bl-p-section").removeClass("active"),$(".bl-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".usage-option").click(function(){$(".usage-option").removeClass("active"),$(this).addClass("active");var e=$(this).attr("data-name");$(".u-p-section").removeClass("active"),$(".u-p-section[data-name=\'"+e+"\']").addClass("active")}),$(".cpc-tr").click(function(){$(".cpc").show().delay(1e3).fadeOut()}),$(".user-dots").on("click",function(){$(this).toggleClass("active")}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-skills-v7.webflow.io");$(this).attr("href",e)}),$(".submit-prompt").click(function(){$(".human-text").removeClass("hide"),setTimeout(function(){$(".s1")[0].style.display="flex"},1e3),setTimeout(function(){$(".s2")[0].style.display="flex"},2e3)}),$(".skills-option").click(function(){var e=$(this).attr("data-name");$(".skills-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$("html, body").animate({scrollTop:$(".scroll-div[data-name="+e+"]").offset().top-79},1e3)}),$(".item_options").each(function(){$(this).mouseover(function(){var e=$(this).closest("a").attr("href");$(this).closest("a").removeAttr("href"),$(this).closest("a").data("default_url",e)}),$(this).mouseout(function(){$(this).closest("a").data("default_url")&&$(this).closest("a").attr("href",$(this).closest("a").data("default_url"))}),$(this).click(function(){0<$(this).closest(".w-slider-mask").length&&($(this).closest(".w-slider-mask")[0].style.overflow="visible",$(".sl_c").css("z-index","auto"),$(this).closest(".sl_c")[0].style.zIndex="5",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="hidden"}),$(this).closest(".w-slide")[0].style.visibility="visible"),$(".options_div").each(function(e){$(this)[0].style.display="none"}),$(this).find(".options_div").toggle()})}),$(".item_options").click(function(e){e.stopPropagation()}),$(window).click(function(){$(".options_div").each(function(e){$(this)[0].style.display="none",0<$(this).closest(".w-slider-mask").length&&($(this).closest(".sl_c")[0].style.zIndex="auto",$(this).closest(".w-slider-mask")[0].style.overflow="hidden",$(this).closest(".w-slide").parent().find(".w-slide").each(function(e){$(this)[0].style.visibility="visible"}))})}),$(".mobile_nav_trigger").click(function(){"block"!=$(".mobile_nav")[0].style.display?$(".mobile_nav")[0].style.display="block":$(".mobile_nav")[0].style.display="none"}),$(window).click(function(){$(".mobile_nav")[0].style.display="none"}),$(".mobile_nav").click(function(e){e.stopPropagation()}),$(".mobile_nav_trigger").click(function(e){e.stopPropagation()}),$(".link-options-2").click(function(){var e=$(this).attr("data-name");$(".link-options-2").each(function(e){$(this).removeClass("active")}),$(this).addClass("active"),$(".panel").each(function(e){$(this).removeClass("active")}),$(".panel[data-name="+e+"]").addClass("active")}),$(".open-chat").click(function(){$(".chatbox").addClass("open"),$(".ch_c").removeClass("hidden")}),$(".minimize").click(function(){$(".chatbox").removeClass("open"),$(".ch_c").addClass("hidden")}),$(".div-block-163").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(".div-block-167").each(function(e){$(this).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"}),$(this).find(".div-block-164").toggle()})}),$(window).click(function(){$(".div-block-164").each(function(e){$(this)[0].style.display="none"})}),$(".div-block-163").click(function(e){e.stopPropagation()}),$(".div-block-167").click(function(e){e.stopPropagation()}),$(".br_menu").click(function(){$(".br_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".browse_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.browse_panel[data-name="\'+e+\'"]\')[0].style.display="flex"}),$(".f_row").each(function(){$(this).click(function(){$(this).find(".img_v").toggle(),$(this).find(".img_h").toggle(),$(this).next().toggle()})}),$(".f_box .text-field.w-input").each(function(){$(this).keyup(function(){let i=$(this).val();var e=$(this).parent().parent().find(".checkbox-field");$(e).each(function(e){0<=$(this).find(".checkbox-label")[0].innerHTML.toLowerCase().indexOf(i.toLowerCase())?$(this)[0].style.display="block":$(this)[0].style.display="none"})})}),$(".feed-option").click(function(){$(".feed-option").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".feed_cont").each(function(e){$(this).removeClass("active")}),$(\'.feed_cont[data-name="\'+e+\'"]\').addClass("active"),"messages"==e||"following"==e||"followers"==e?$("body").addClass("messages_active"):$("body").removeClass("messages_active")});var e=window.location.href,e=(console.log(e),e.split("#")[1]);function i(){$(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"),$(".tw_r.new_m_user").each(function(e){$(this).removeClass("active")})}e&&(e=document.querySelector(\'.prof_menu[data-name="\'+e+\'"]\'))&&e.click(),document.getElementById("pink0").oninput=function(){var e=(this.value-this.min)/(this.max-this.min)*100;this.style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+e+"%, #fff "+e+"%, white 100%)"},$("input[type=range]").on("input",function(){var t=$(this).attr("data-index"),l=$(this).val();$("#i"+t).html(l);{let i=0;$(".is-pink0").each(function(e){0<$(this).val()&&(i+=1)}),console.log(i),$("#rs").html(i),3==i?($(".skills_allow")[0].style.display="flex",$(".skills_next0").hide()):($(".skills_allow").hide(),$(".skills_next0").show())}{let e="",i="";0==l?(e="NOT RATED",i="0"):1==l?(e="BEGINNER",i="10px"):2==l?(e="NOVICE",i="60px"):3==l?(e="INTERMEDIATE",i="80px"):4==l?(e="ADVANCED",i="130px"):5==l&&(e="EXPERT",i="160px"),$(".level-text")[t].style.marginLeft=i,$(".level-text")[t].innerHTML=e}l=$(this)[0],t=(l.value-l.min)/(l.max-l.min)*100;$(this)[0].style.background="linear-gradient(to right, #4a78b8 0%, #6cafe1 "+t+"%, #e9eaeb "+t+"%, #e9eaeb 100%)"}),$(".is-pink0").on("touchstart",function(e){}),$(".is-pink0").on("touchend",function(){}),$(".more").click(function(){$(this).hide(),$(".link-block-7").each(function(e){$(this).removeClass("hide")})}),$(".down_arr").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$(".skills_next0.disabled").click(function(){$("html, body").animate({scrollTop:$(document).height()},1e3)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$("a").each(function(){var e=(e=$(this).attr("href")).replace("ibl-skills-v2.webflow.io","ibl-wgu-skills-v3.webflow.io");$(this).attr("href",e)}),$(".c-block").click(function(){$(".cm_popup_div")[0].style.display="flex"}),$(".comment-c").click(function(){$(".cm_popup_div")[0].style.display="none"}),$(".tw-img-trigger").click(function(){$("#tw-img-uploader").trigger("click")}),$(".likes_tab").click(function(){$(".likes_tab").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".profile_text").each(function(e){$(this).removeClass("active")}),$(\'.profile_text[data-name="\'+e+\'"]\').addClass("active"),$(".profile_list").each(function(e){$(this).removeClass("active")}),$(\'.profile_list[data-name="\'+e+\'"]\').addClass("active")}),$(".message_div .tw_r").click(function(){$(".message_div").addClass("mobile_hidden"),$(".chat_div").removeClass("mobile_hidden")}),$(".show_msg_div").click(function(){$(".message_div").removeClass("mobile_hidden"),$(".chat_div").addClass("mobile_hidden")}),$(".follow_tab").click(function(){var e=$(this).attr("data-name");e&&$(\'.feed-option[data-name="\'+e+\'"]\').click()}),$(".follow_tabs_back").click(function(){$(\'.feed-option[data-name="home"]\').click()}),$(".create-group").click(function(){$(".create_group_popup").removeClass("hidden"),$(".new_message_popup").addClass("hidden")}),$(".back_dc").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden")}),$(".cancel_user.c_i").click(function(){i()}),$(".next_form.n_m.next").click(function(){$(".create_group_popup").addClass("hidden"),$(".new_message_popup").removeClass("hidden"),$(this).hasClass("disabled")||($(".nm_popup")[0].style.display="none",i())}),$(".new_message").click(function(){$(".nm_popup")[0].style.display="flex"}),$(".tw_r.new_m_user").each(function(e){$(this).click(function(){$(this).toggleClass("active");let i=!1;$(".tw_r.new_m_user").each(function(e){$(this).hasClass("active")&&(i=!0)}),i?($(".n_m.next").removeClass("disabled"),$(".create-group").addClass("hide"),$(".group-users").addClass("show")):($(".n_m.next").addClass("disabled"),$(".create-group").removeClass("hide"),$(".group-users").removeClass("show"))})}),$(".div-block-181").each(function(e){$(this).click(function(){$(this).find(".div-block-193").toggle()})}),$(".cancel_type_popup").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".cancel_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".add_type_btn").click(function(){$(".add_content_popup")[0].style.display="block",$(".type_content_popup")[0].style.display="none"}),$(".div-block-176").each(function(e){$(this).click(function(){$(".add_content_popup")[0].style.display="none",$(".type_content_popup")[0].style.display="block"})}),$(".content_menu").click(function(){$(".content_menu").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this).attr("data-name");$(".conent_panel").each(function(e){$(this)[0].style.display="none"}),$(\'.conent_panel[data-name="\'+e+\'"]\')[0].style.display="block","type"==e?$(".add_content_btn").addClass("disabled"):$(".add_content_btn").removeClass("disabled")}),$(".add_content_div").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_content_popup")[0].style.display="block"})}),$(".add_content_btn").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_content").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".cancel_add_popup").click(function(){$(".popup_div")[0].style.display="none",$(".body")[0].style.overflow="visible",$(".dc_popup")[0].style.display="none"}),$(".dc").click(function(){$(".popup_div")[0].style.display="flex",$(".body")[0].style.overflow="hidden",$(".dc_popup")[0].style.display="block"}),$(".cancel_dc").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_dc_div").click(function(){$(".popup_div")[0].style.display="none",$(".dc_popup")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_profile_trigger").click(function(){$(".popup_div")[0].style.display="flex",$(".edit_profile_pop")[0].style.display="block",$(".body")[0].style.overflow="hidden"}),$(".cancel_edit_profile").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".cancel_edit_prof").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".save_profile_info").click(function(){$(".popup_div")[0].style.display="none",$(".edit_profile_pop")[0].style.display="none",$(".body")[0].style.overflow="visible"}),$(".edit_rating").click(function(){$(".skill_report_popup")[0].style.display="none",$(".rate_skill_popup")[0].style.display="block"}),$(".rate_skill_close").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".cancel_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".confirm_skill_rate").click(function(){$(".skill_report_popup")[0].style.display="block",$(".rate_skill_popup")[0].style.display="none"}),$(".skill_box").each(function(e){$(this).click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".skill_report_popup").toggle()})}),$(".cancel_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".confirm_skill_report").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".skill_report_popup")[0].style.display="none"}),$(".add_skill").click(function(){$(".body")[0].style.overflow="hidden",$(".popup_div")[0].style.display="flex",$(".add_skill_popup").toggle()}),$(".confirm_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".cancel_add_skill").click(function(){$(".body")[0].style.overflow="visible",$(".popup_div")[0].style.display="none",$(".add_skill_popup")[0].style.display="none"}),$(".dash_nav_item").click(function(){$(".dash_nav_item").each(function(e){$(this).removeClass("active")}),$(this).addClass("active");var e=$(this)[0].innerHTML;$(".panel").each(function(e){$(this)[0].style.display="none"}),$(".panel-"+e.toLowerCase())[0].style.display="flex"}),window.location.hash.substr(1)&&(console.log("fires"),e=window.location.hash.substr(1),$(\'.prof_menu[data-name="\'+e+\'"]\').click());e=new URL(window.location.href).searchParams.get("s");console.log(e),e&&$(\'.prof_menu[data-name="\'+e+\'"]\').trigger("click")}),jQuery.fn.onPositionChanged=function(t,e){null==e&&(e=100);var l,o,s=$(this[0]);return s.length<1||(o=l=null,setInterval(function(){if(null==s||s.length<1)return s;null==l&&(l=s.position()),null==o&&(o=s.offset());var e=s.position(),i=s.offset();l.top==e.top&&l.left==e.left||($(this).trigger("onPositionChanged",{lastPos:l,newPos:e}),"function"==typeof t&&t(l,e),l=s.position()),o.top==i.top&&o.left==i.left||($(this).trigger("onOffsetChanged",{lastOff:o,newOff:i}),"function"==typeof t&&t(o,i),o=s.offset())},e)),s},$(window).on("scroll",function(){$(window).scrollTop()+$(window).height()==$(document).height()?$(".down_arr").hide():$(".down_arr").show()});'
    ),
    isAsync: false,
  },
  {
    loading: Promise.resolve(
      '$(document).ready(function(){var t=$("#email-form-4"),e=$("<div>").append(t.contents()),t=(t.replaceWith(e),$(".div-block-276.second .form-2")),e=$(\'<div class="second-input">\').append(t.contents());t.replaceWith(e)}),$(".ask-input").keydown(function(t){13==t.which&&""!=$(".ask-input").val()&&$(".div-block-305.fire-f").trigger("click")}),$(".form-block-8").removeClass("w-form"),$(".close-box").click(function(){$(".body").removeClass("chat-active")}),$(".div-block-305.fire-f").click(function(t){var e,o,s;""!=$(".ask-input").val()&&($(".div-block-276.first")[0].style.display="none",$(".div-block-276.second")[0].style.display="flex",e=0,o="Quantum computing is a field that aims to develop computers that use the principles of quantum physics to perform computations.",s=20,setTimeout(function t(){var i,n;$(".history").removeClass("hidden"),e<o.length?($(".text-block-187")[0].innerHTML+=o.charAt(e),e++,s=Math.floor(15*Math.random())+1,setTimeout(t,s)):($(".text-block-187")[0].classList.add("no-after"),i=0,n="One of the most important concepts in quantum computing is superposition, which allows qubits to be in multiple states simultaneously.",setTimeout(function(){$(".text-block-187")[1].style.display="block",function t(){var e,o;i<n.length?($(".text-block-187")[1].innerHTML+=n.charAt(i),i++,s=Math.floor(10*Math.random())+1,setTimeout(t,s)):($(".text-block-187")[1].classList.add("no-after"),$(".reg-btn").removeClass("hidden"),$(".sources").removeClass("hidden"),$(".related").removeClass("hidden"),$(".reg").addClass("reg-show"),$(".new-chat-text").html(""),$(".new-chat-text").addClass("with_blink"),e=0,o="Quantum computing",setTimeout(function(){$(".text-block-169")[1].style.display="block",function t(){$(".div-block-325").addClass("rel"),e<o.length?($(".new-chat-text")[0].innerHTML+=o.charAt(e),e++,s=Math.floor(100*Math.random())+4,setTimeout(t,s)):$(".new-chat-text").removeClass("with_blink")}()},1e3))}()},10))},2e3))});'
    ),
    isAsync: false,
  },
];

let Controller;

class SocialView extends React.Component {
  static get Controller() {
    if (Controller) return Controller;

    try {
      Controller = require('../controllers/SocialController');
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = SocialView;

        return Controller;
      }

      throw e;
    }
  }

  componentDidMount() {
    const htmlEl = document.querySelector('html');
    htmlEl.dataset['wfPage'] = '6596e21ac435cac3c66baaee';
    htmlEl.dataset['wfSite'] = '6596e21ac435cac3c66baad8';

    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          new Function().call(window, script);
          return next;
        });

        return active.isAsync ? next : loading;
      })
    );
  }

  render() {
    const proxies =
      SocialView.Controller !== SocialView
        ? transformProxies(this.props.children)
        : {};

    return (
      <span>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/ibl-skillspro-v3.webflow.css);


            .full.w-bar .right-content {
              display: flex !important;
              flex-direction: column !important;
          }
            @media screen and (min-width: 768px)  and  (max-width: 1090px){
              .div-block-19.cert-grid{
                  grid-template-columns: 1fr;
              }
          }
            .pr-text:after, .pr-text-2:after, .pr-text-3:after, .pr-text-4:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .div-block-346{
            	border-radius:2px;
            }
            .up{
            	white-space: nowrap;
            }
            .text-block-189{
            	margin-bottom:15px;
            }
            .div-block-345.u-p-section, .div-block-345.bl-p-section{
            	padding-top:15px !important;
            }
            .div-block-352.three-dots-menu{
            	height:132px !important;
            }
            .text-block-203{
            	margin-bottom:15px;
            }
            .div-block-357{
            	padding-bottom:12px;
            }
            .form-block.s_skill.r-search.s-r.search-admin{
            	margin-bottom:15px;  
            }
            .div-block-345.bl-p-section{
              	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .div-block-345.d-p-section{
            	padding:12px;
              padding-left:10px;
              padding-right:10px;
            }
            .cpc{
             margin-top:4px !important;
            }
            .user-dots.active{
              background-color: #f7f9fd;
          }
            .d-admin-m{
              height: 36px !important;
              width:152px !important;
          }
            .user-dots.active .d-admin-m{
              display:block; 
          }
            .pm-33{
            	height: 100%;
              display: flex;
              flex-direction: column;
            }
            .pm-272{
            	display: flex;
              flex-direction: column;
              flex-grow: 1;
            }
            .div-block-358{
            	    flex-grow: 1;
                  align-items: start;
            }
            .chat-box.logged-in.jc-start{
            	justify-content:start !important;
            }
          @media only screen and (max-width: 767px) {
              .text-block-167.new-chat-text, .text-block-186,  .text-block-184, .text-block-169 , .text-field-11.ask-input, .all,
              .text-block-192, .rel-answer.open .answer-text, .text-block-189, .textarea-2, .w_i, .create-text, .add-text,
              .rec-h, .text-field.n_text.s-f, .text-block-167.add-resource, .text-block-199, .text-field-12, .text-block-159-train, .text-block-196,
              .text-block-198, .text-block-160, .div-block-340-train .link-options-train, .text-block-165-tr, .text1-tr, .paragraph-tr, .text-block-163-tr, .text-block-86-tr,
              .text-block-86-tr, .instructor-name-train, .instructor-subtitle-train, .instructor-school-train, .text-block-165-train, .text-block-26, 
              .text-block-197, .test-name-3, .text-block-86, .text-block-120, .text-block-86, .question-title-te
              {
                  font-size: 16px !important;
              }
                .instructor-img-train{
                  width: 70px !important;
                  height: 70px !important
              }
              .text-block-191, .text-block-190, .b-link{
                  font-size:14px;
              }
              .image-45{
                  height:18px;
              }
              .content-2.r-hide{
                  padding-bottom:14px !important
              }
              .text-block-16.p, .text-block-124{
                  font-size:13px;
              }
          }
            @media only screen and (max-width: 767px) {
              .sign-in-panel {
              	padding-top:49px;
              }
              .chat-box-sign-in.hidden.open{
              border:none !important;
                height: auto !important;
              }
            }
            .chat-box-sign-in.hidden.open{
            	height:auto;
              padding-bottom:12px;
          	    	    margin-right:0;
              height:100%;
            }
            .or-3-copy{
            	text-align:center;
            }
            .chat-box-sign-in.hidden{
            	    border: 1px solid #dde1e6 !important;
            }
            .chat-1 .content-2{
            	padding-bottom:0 !important;
            }
            .div-block-305:hover {
              background-color: #fff;
          }
            .related_f{
            	display:none;
            }
            .sources_f{
            	display:none;
            }
            .create-div .text-field{
            	width: 100%;
            }
            .add_content_popup .div-block-333{
            	flex: inherit !important;
            }
            .b-link:hover{
            	text-decoration: underline;
            }
            .div-block-347{
            	padding:10px;
              z-index: 2222;
            }
            .b-link{
            	margin-right:6px !important;
            }
            .div-block-262.last{
            	padding-bottom:3px;
            }
            .about_p_popup_resource .about-box-train .faq-question-wrap-2{
              margin-bottom:0;
            }
              .about_p_popup_resource .faq-question-bar-2{
              padding-bottom:0;
            }
            .link-options-train.link-options:hover{
            	border-bottom: 2px solid #6cafe1;
            }
            .about-box-train .text-block-120{
            	    color: #6cafe1;
            }
            .question-title-te, .test-name-3{
             color: #6cafe1;
            }
            .link-options-train{
            	padding-right:0 !important;
            }
            .div-block-340-train{
            	padding-bottom:5px;
            }
            .about-box-train .faq-question-wrap-2{
            	padding-bottom:0;
            }
            .about-vox-train .accordion__title__faq-2{
            	padding:10px !important;
            }
            .about-box-train .div-block-270{
             padding:10px;
            }
            .link-options-train{
            	font-size:14px !important;
            }
            .rec-h{
            	height:40px;
            }
            .outcome-train .image-118{
            	width:16px;
              height:16px;
            }
            .div-block-333{
            	overflow:hidden;
            }
            .outcome-train .skill-div-2{
            	margin-bottom:5px;
              float:left !important;
              clear:both;
            }
            .outcome-train{
            	overflow:hidden;
            }
            .textarea-2{
            	height:250px !important;
              border-radius: 6px;
            }
            .text-block-187-sum:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .chat-1.hidden{
            	display:none;
            }
            .div-block-272{
            	z-index: 222;
            }
            .div-block-329{
            	max-width:350px;
            }
            .chat-box.hidden{
            	flex-grow: 1;
            }
            .chat-box.hidden.h-auto{
            	height: auto !important;
            }
            .rel-answer.open .answer-text{
            	display:block;
            }
            .right-content {
            	    max-height: 100vh;
              overflow: auto;
            }
            .div-block-325.rel{
            	padding-top:14px;
            }
            .h-hide{
            	display:none !important;
            }
            .all .grow-flex{
            	    overflow: auto;
            }
            .rec-div:hover .div-block-332{
              display: block;
          }
            @media screen and (max-width: 767px) {
              .all .grow-flex{
                  max-height: 89vh;
              }
          }
          /* .all .div-block-325.rel{
              position:absolute !important;
          } */
                .div-block-294-open:hover > .hidden-img{
              display:none;
          }
          .div-block-294-open:hover > .hidden-img-rot{
              display:block;
          }
            .rel-answer.open .answer-text{
              height: auto;
              margin-bottom:10px;
          }
            .div-block-294:hover > .image-116{
              display:none;
          }
          .div-block-294:hover > .image-93-rot{
              display:inline-block;
          }
            .rel-row.open .div-block-294{
              display:none;
          }
          .rel-row.open .div-block-294-open{
              display:inline-block;
          }
            .chat-response .form-2{
            	height:40px;
            }
            .chat-box.hidden{
            	height:100% !important;
            }
            .graphs-row{
                	overflow: auto !important;
            }
            .second-input{
            	display:flex;
              align-items:center;
            }
            	@media screen and (max-width: 767px) {
                    .html-embed-2.skill-point.dblock.w-embed.w-script{
                  overflow: auto !important;
                min-width: 600px !important;
              }
                    .reg-show{
                  display: block;
              }
              .form-block-8{
                  padding-top: 0;
              }
                	    .div-block-280{
                  display: none;;
              }
                	    .div-block-272{
                  position: fixed;
                  top: 0;
                  width: 100%;
                  background: #fff;
              }
              .div-block-52{
                  padding-top: 59px;
              }
                	    .chat-2{
                  position: fixed;
                  bottom: 0;
                  width: 100%;
                  background: #fff;
                                margin-bottom: 0;
                  padding-bottom: 14px;
              }
                    .content-2{
                  padding-bottom:100px;
              }
                	    .full.w-bar .chat-box.hidden{
                  border-radius: 0;
                  border: none !important;
              }
                	    .body.chat-active{
                  overflow: hidden;
              }
             .full.w-bar .image-106.right{
                  padding-right:13px;
              } 
              .div-block-325{
                  position: fixed !important;
                  background: #fff;
                  padding-top:12px;
                        margin-left: 0;
                  margin-right: 0;
                        padding-left: 10px;
                  padding-right: 10px;
              }
              .grow-flex{
                  padding-bottom: 66px;
              }
              .full.w-bar .right-content{
                  width: 100% !important;
                        overflow: auto;
                        padding: 0;
              }
              .chat-box{
                  min-height: auto;
                  height:auto;
                  flex-grow: 1;
              }
              .mob-grid{
                  margin-left: auto;
                  margin-right: auto;
              }
              .resize-img{
                  display: none;;
              }
                    .div-block-326{
                  min-width: auto !important;
              }
            }
              @media screen and (max-width: 390px) {
              .div-block-275{
                  margin-right: 8px;
              }
          }
              .with_blink:after{
            	-webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
              color: #21232e;
            }
            	  .no-after:after{
            	content:\"\" !important;
            }
            @keyframes blink {
            0% {
              display: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          /* Apply the animation to an element */
          .blink {
            animation: blink 1s ease-in-out infinite;
          }
          .text-block-187:after{
                -webkit-animation: blink 1s steps(5,start) infinite;
              animation: blink 1s steps(5,start) infinite;
              content: \"▋\";
              margin-left: 0.25rem;
              vertical-align: baseline;
            color: #21232e;
          }
            .full.w-bar .p_menu {
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
              .chat-box.active.hidden{
            	border-radius: 4px;
            }
          .full.w-bar .right-content{
              display: flex !important;
              flex-direction: column !important;
          }
            .full.w-bar .image-116.right .sm{
              margin-left: auto;
          }
            .full.w-bar .chat-box.hidden{
              display: flex;
          }
            .full.w-bar .p_menu.w_bar{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            .full.w-bar .panels_cont{
              margin-right: 3% !important;
              margin-left: 3% !important;
              max-width: none !important;
          }
            	.full.w-bar .main-content{
              padding-right:380px;
          }
            .full.w-bar .right-content{
              display: block;
          }
          .full.w-bar .right-content{
              width:380px;
          }
            .chat-box{
            	width:auto !important;
              border: 1px solid #dde1e6 !important;
            }
            .about-panels{
              min-height: calc(100vh - 79px - 59px);
          }
          @media screen and (max-width: 767px)  and (min-width: 480px){
            .chatbox.open .open-chat{
              display: none;
            }
            .ch_c{
              margin-bottom: 0;
            }
          }
            .chatbox {
            padding-bottom: env(safe-area-inset-bottom);
                padding-top: env(safe-area-inset-top);
          }
              .about-body{
            	  min-height: calc(100vh - (79px + 58px))
            }
            input[type=range] {
            border-radius: 8px;
            height: 7px;
            outline: none;
            transition: background 450ms ease-in;
            -webkit-appearance: none;
          }
            .fs-rangeslider_track{
            	pointer-events: none;
            }
            .is-pink{
            	    pointer-events: auto;
            }
            .menicon{
            	    -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-image: linear-gradient(90deg, #4a78b8, #6cafe1);
            }
            .messages_active .al-m.active {
            margin-bottom: 0;
          }
            .tw_r.new_m_user.active .user_tick{
            display: block;
          }
            .body.messages_active .panels{
            padding-bottom: 0;
          }
          .body.messages_active .panels_cont{
          padding-bottom: 0;
          }
            .feed-option.active .tw_t{
            font-weight: 500;
          }
              ::-webkit-scrollbar {
            width: 6px;
            height: 6px;
          }
          ::-webkit-scrollbar-track {
            border-radius: 10px;
            background: rgba(0,0,0,0.1);
          }
          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background: rgba(0,0,0,0.2);
          }
          ::-webkit-scrollbar-thumb:hover{
            background: rgba(0,0,0,0.4);
          }
          ::-webkit-scrollbar-thumb:active{
            background: rgba(0,0,0,.9);
          }
            .add_content_btn.disabled{
            	opacity:0.7;
            }
            .text-block-16{
            overflow-wrap: break-word;
            }
            @media screen and (max-width: 1231px) {
          .results{
            grid-template-columns: 1fr 1fr;
          }
          }
            .inner span {
           	position: relative;
              top:2px;
            }
            .s_box{
                appearance: none;
              background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'currentColor\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3e%3cpolyline points=\'6 9 12 15 18 9\'%3e%3c/polyline%3e%3c/svg%3e\");
              background-repeat: no-repeat;
              background-position: right 7px center;
              background-size: 1em;
            }
              @media screen and (max-width: 479px) {
          .results{
            grid-template-columns: 1fr;
          }
          }
          @media screen and (max-width: 1250px) and (min-width: 991px) {
            .slider.w-slider .link-block-7:last-child{
              display: none;
            }
            .div-block-42.sl{
              grid-template-columns: 1fr 1fr 1fr;
            }
          }
            .div-block-78{
            	min-height: calc(100vh - 78px - 70px);
            }
            @media screen and (max-width: 479px) {
           .div-block-78{
            	min-height: calc(100vh - 78px - 101px);
            }
          }
            <style>
            .wday, .month{
            fill: #6d717f;
          }
          .float-right{
            color: #6d717f;
          }
            .more:hover {
                  background-color: #fff;
              background-image: none !important;
          }
            @media screen and (max-width: 479px){
              .dots{
              	    left: calc(50% - 19px);
              }
            }
            	  .chat-box.hidden{
            	height: auto !important;
            }
            @media screen and (max-width: 767px) {
              .chat-box.hidden{
                  height: 100% !important;
              }
                  .full.w-bar .main-content{
                  display:none;
              }
          }
            .chat-2{
            	padding-top: 14px;
            }
            .chat-box.logged-in.hidden{
            	display:none;
            }
        `,
          }}
        />
        <span className="af-view">
          <div className="body">
            <div className="full">
              <div className="main-content">
                <div className="div-block-326">
                  <div className="nav">
                    <div className="l-nav">
                      <div className="p_menu">
                        <a className="w-inline-block" href="index.html">
                          <img
                            alt=""
                            className="image"
                            loading="lazy"
                            src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                          />
                        </a>
                        <div className="div-block-231">
                          <a className="dash_nav_item" href="index.html">
                            Home
                          </a>
                          <a className="dash_nav_item" href="activity.html">
                            Profile
                          </a>
                          <a
                            aria-current="page"
                            className="dash_nav_item active w--current"
                            href="social.html"
                          >
                            Social
                          </a>
                          <a className="dash_nav_item" href="recommended.html">
                            Recommended
                          </a>
                          <a className="dash_nav_item" href="browse.html">
                            Discover
                          </a>
                        </div>
                        <div className="prof_menu hidden" data-name="feed">
                          Feed
                        </div>
                        <div className="nav-right">
                          <div className="div-block-170">
                            <div className="form-block w-form">
                              <form
                                className="form"
                                data-name="Email Form"
                                data-wf-element-id="b6b3f154-17f6-ebc7-fb45-a1f76d0dd6db"
                                data-wf-page-id="6596e21ac435cac3c66baaee"
                                id="email-form"
                                method="get"
                                name="email-form"
                              >
                                <div className="div-block">
                                  <img
                                    alt=""
                                    className="image-2"
                                    loading="lazy"
                                    src="images/magnifying-glass_1magnifying-glass.png"
                                  />
                                </div>
                                <input
                                  className="text-field n_text w-input"
                                  data-name="Email 8"
                                  id="email-8"
                                  maxLength={256}
                                  name="email-8"
                                  placeholder="Search"
                                  required=""
                                  type="email"
                                />
                              </form>
                              <div className="w-form-done">
                                <div>
                                  Thank you! Your submission has been received!
                                </div>
                              </div>
                              <div className="w-form-fail">
                                <div>
                                  Oops! Something went wrong while submitting
                                  the form.
                                </div>
                              </div>
                            </div>
                            <div
                              className="div-block-163"
                              data-w-id="b6b3f154-17f6-ebc7-fb45-a1f76d0dd6e5"
                            >
                              <img
                                alt=""
                                className="image-3"
                                loading="lazy"
                                src="images/bell.png"
                              />
                              <img
                                alt=""
                                className="image-3h"
                                loading="lazy"
                                src="images/629f2ca4ae5641d483147dd9_bell.png"
                              />
                              <div className="div-block-164">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Notifications
                                  </div>
                                </div>
                                <div className="div-block-166">
                                  <div className="text-block-105">
                                    There are no new notifications
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="div-block-167">
                              <img
                                alt=""
                                className="image-4"
                                loading="lazy"
                                src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                              />
                              <img
                                alt=""
                                className="image-5"
                                loading="lazy"
                                src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                              />
                              <div className="div-block-164 profile">
                                <div className="div-block-165">
                                  <div className="text-block-104">
                                    Ashley Miller
                                  </div>
                                  <div className="text-block-104 em">
                                    ashley@gmail.com
                                  </div>
                                </div>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="public-profile.html"
                                >
                                  <div className="text-block-106">Profile</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Settings</div>
                                </a>
                                <a
                                  className="link-block-11 w-inline-block"
                                  href="#"
                                >
                                  <div className="text-block-106">Log Out</div>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mobile_nav_trigger">
                          <div className="menicon"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mobile_nav">
                    <div className="mob_nav">
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="index.html">
                          Home
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a className="dash_nav_item" href="activity.html">
                          Profile
                        </a>
                      </div>
                      <div className="div-block-171">
                        <a
                          aria-current="page"
                          className="dash_nav_item active w--current"
                          href="social.html"
                        >
                          Social
                        </a>
                      </div>
                      <div className="div-block-171 last">
                        <a className="dash_nav_item" href="browse.html">
                          Browse
                        </a>
                      </div>
                    </div>
                    <div className="mob_nav">
                      <div className="form-block mobile w-form">
                        <form
                          className="form"
                          data-name="Email Form"
                          data-wf-element-id="fb7899fa-2d6f-4c5d-ba81-c4611f7cf0b0"
                          data-wf-page-id="6596e21ac435cac3c66baaee"
                          id="email-form"
                          method="get"
                          name="email-form"
                        >
                          <div className="div-block">
                            <img
                              alt=""
                              className="image-2"
                              loading="lazy"
                              src="images/magnifying-glass_1magnifying-glass.png"
                            />
                          </div>
                          <input
                            className="text-field n_text w-input"
                            data-name="Email 7"
                            id="email-7"
                            maxLength={256}
                            name="email-7"
                            placeholder="Search"
                            required=""
                            type="email"
                          />
                        </form>
                        <div className="w-form-done">
                          <div>
                            Thank you! Your submission has been received!
                          </div>
                        </div>
                        <div className="w-form-fail">
                          <div>
                            Oops! Something went wrong while submitting the
                            form.
                          </div>
                        </div>
                      </div>
                      <div className="div-block-172">
                        <div className="div-block-163">
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            src="images/bell.png"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/629f2ca4ae5641d483147dd9_bell.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Notifications
                              </div>
                            </div>
                            <div className="div-block-166">
                              <div className="text-block-105">
                                There are no new notifications
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="div-block-163">
                          <img
                            alt=""
                            className="image-3"
                            loading="lazy"
                            sizes="(max-width: 479px) 100vw, (max-width: 767px) 22px, 100vw"
                            src="images/setting.png"
                            srcset="images/setting-p-500.png 500w, images/setting.png 512w"
                          />
                          <img
                            alt=""
                            className="image-3h"
                            loading="lazy"
                            src="images/62a1d584bc8cea2ba5c40d38_setting-p-500.png"
                          />
                          <div className="div-block-164">
                            <div className="div-block-165">
                              <div className="text-block-104">Settings</div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="https://ibl-skills.webflow.io/profile#pp"
                            >
                              <div className="text-block-106">
                                Profile Settings
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="div-block-167">
                          <img
                            alt=""
                            className="image-4"
                            loading="lazy"
                            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                          />
                          <img
                            alt=""
                            className="image-5"
                            loading="lazy"
                            src="images/629f2d70ada2d5ad683a0982_down-arrow_1629f2d70ada2d5ad683a0982_down-arrow.png"
                          />
                          <div className="div-block-164 profile">
                            <div className="div-block-165">
                              <div className="text-block-104">
                                Ashley Miller
                              </div>
                              <div className="text-block-104 em">
                                ashley@gmail.com
                              </div>
                            </div>
                            <a
                              className="link-block-11 w-inline-block"
                              href="activity.html"
                            >
                              <div className="text-block-106">Overview</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="public-profile.html"
                            >
                              <div className="text-block-106">Profile</div>
                            </a>
                            <a
                              className="link-block-11 w-inline-block"
                              href="#"
                            >
                              <div className="text-block-106">Log Out</div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="panels">
                    <div className="panels_cont">
                      <div className="div-block-174">
                        <div className="profile_menu">
                          <div
                            className="prof_menu first active"
                            data-name="mf"
                          >
                            Channels
                          </div>
                          <div className="prof_menu" data-name="sh">
                            Community Content
                          </div>
                          <div className="prof_menu hidden" data-name="feed">
                            Feed
                          </div>
                          <div className="prof_menu" data-name="people">
                            People
                          </div>
                        </div>
                      </div>
                      <div className="panel-home panel">
                        <div className="ov_panel active" data-name="mf">
                          <div className="social">
                            <div className="div-block-190">
                              <div className="f-sidebar">
                                <div
                                  className="feed-option active"
                                  data-name="home"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/home_1home.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Feed
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="explore"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/hastag.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Explore
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="discussion"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/chat_1chat.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Discussions
                                    </div>
                                  </a>
                                </div>
                                <div className="feed-option" data-name="teams">
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/group_1group.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Teams
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="messages"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/email.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Messages
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="following"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                                    src="images/add.png"
                                    srcset="images/add-p-500.png 500w, images/add.png 512w"
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Following
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="followers"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    src="images/users-2.png"
                                    width={20}
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Followers
                                    </div>
                                  </a>
                                </div>
                                <div
                                  className="feed-option"
                                  data-name="profile"
                                >
                                  <img
                                    alt=""
                                    className="f-i s"
                                    loading="lazy"
                                    sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                                    src="images/user-4.png"
                                    srcset="images/user-4-p-500.png 500w, images/user-4.png 512w"
                                  />
                                  <a
                                    className="link-block-17 w-inline-block"
                                    href="#"
                                  >
                                    <div className="text-block-122 tw_t">
                                      Profile
                                    </div>
                                  </a>
                                </div>
                                <div className="div-block-249">
                                  <div className="pr_g f lf ma soc-act">
                                    <div className="div-block-14">
                                      <div className="skm soc-ac">
                                        Monthly Activity
                                      </div>
                                    </div>
                                    <div>
                                      <div className="div-block-20">
                                        <div className="div-block-21">
                                          <img
                                            alt=""
                                            className="image-17"
                                            loading="lazy"
                                            src="images/google-docs_3google-docs.png"
                                          />
                                        </div>
                                        <div className="text-block-14">
                                          Posts
                                        </div>
                                        <div className="text-block-15">32</div>
                                      </div>
                                      <div className="div-block-20">
                                        <div className="div-block-21">
                                          <img
                                            alt=""
                                            className="image-17"
                                            loading="lazy"
                                            src="images/like_1like.png"
                                            width={12}
                                          />
                                        </div>
                                        <div className="text-block-14">
                                          Likes
                                        </div>
                                        <div className="text-block-15">134</div>
                                      </div>
                                      <div className="div-block-20">
                                        <div className="div-block-21">
                                          <img
                                            alt=""
                                            className="image-17"
                                            loading="lazy"
                                            src="images/chat_2chat.png"
                                            width={12}
                                          />
                                        </div>
                                        <div className="text-block-14">
                                          Comments
                                        </div>
                                        <div className="text-block-15">40</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="feed-option sm media">
                                  <img
                                    alt=""
                                    className="f-i vo tw"
                                    loading="lazy"
                                    src="images/share-2.png"
                                  />
                                  <div className="div-block-4 s tw">
                                    <a
                                      className="link-block-10 f tw w-inline-block"
                                      data-w-id="ccaf14c8-0ec9-2047-1d06-a1dcb45d365d"
                                      href="#"
                                    >
                                      <img
                                        alt=""
                                        className="image-77"
                                        loading="lazy"
                                        sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                                        src="images/facebook-1_1.png"
                                        srcset="images/facebook-1_1-p-500.png 500w, images/facebook-1_1.png 512w"
                                      />
                                      <img
                                        alt=""
                                        className="_77_h"
                                        loading="lazy"
                                        sizes="(max-width: 479px) 0px, 100vw"
                                        src="images/facebook-1_2.png"
                                        srcset="images/facebook-1_2-p-500.png 500w, images/facebook-1_2.png 512w"
                                      />
                                    </a>
                                    <a
                                      className="link-block-10 tw w-inline-block"
                                      data-w-id="ccaf14c8-0ec9-2047-1d06-a1dcb45d3660"
                                      href="#"
                                    >
                                      <img
                                        alt=""
                                        className="image-77"
                                        loading="lazy"
                                        sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                                        src="images/lk0.png"
                                        srcset="images/linkedin-2-p-500.png 500w, images/lk0.png 512w"
                                      />
                                      <img
                                        alt=""
                                        className="_77_h"
                                        loading="lazy"
                                        sizes="(max-width: 479px) 0px, 100vw"
                                        src="images/linkedin-2_1.png"
                                        srcset="images/linkedin-2_1-p-500.png 500w, images/linkedin-2_1.png 512w"
                                      />
                                    </a>
                                    <a
                                      className="link-block-10 tw w-inline-block"
                                      data-w-id="ccaf14c8-0ec9-2047-1d06-a1dcb45d3663"
                                      href="#"
                                    >
                                      <img
                                        alt=""
                                        className="image-77"
                                        loading="lazy"
                                        sizes="(max-width: 767px) 18px, (max-width: 991px) 2vw, (max-width: 1279px) 18px, 1vw"
                                        src="images/tw0.png"
                                        srcset="images/twitter-2-p-500.png 500w, images/tw0.png 512w"
                                      />
                                      <img
                                        alt=""
                                        className="_77_h"
                                        loading="lazy"
                                        sizes="(max-width: 479px) 0px, 100vw"
                                        src="images/twitter-2.png"
                                        srcset="images/twitter-2-p-500.png 500w, images/twitter-2.png 512w"
                                      />
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <div className="div-block-192">
                                <div
                                  className="feed_cont al-m nw active"
                                  data-name="home"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page active"
                                      data-name="home"
                                    >
                                      <div className="feed-box ns">
                                        <div className="text-block-130">
                                          Feed
                                        </div>
                                        <div className="f_pfp my">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                          />
                                          <div className="div-block-180">
                                            <div className="form-block-6 w-form">
                                              <form
                                                data-name="Email Form 2"
                                                data-wf-element-id="c7d2b913-b1e7-c4ec-6941-4113b5e791fc"
                                                data-wf-page-id="6596e21ac435cac3c66baaee"
                                                id="email-form-2"
                                                method="get"
                                                name="email-form-2"
                                              >
                                                <input
                                                  className="text-field-8 w-input"
                                                  data-name="Name"
                                                  id="name"
                                                  maxLength={256}
                                                  name="name"
                                                  placeholder="Start a post"
                                                  type="text"
                                                />
                                              </form>
                                              <div className="div-block-185">
                                                <div className="div-block-184">
                                                  <div className="div-block-183">
                                                    <div className="c_icon tw-img-trigger">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/image-1_1image-1.png"
                                                      />
                                                    </div>
                                                    <div className="media-upload">
                                                      <div className="html-embed-6 w-embed">
                                                        <form action="">
                                                          <input
                                                            accept="image/png, image/gif, image/jpeg"
                                                            id="tw-img-uploader"
                                                            name="twIMG"
                                                            type="file"
                                                          />
                                                        </form>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div className="div-block-183">
                                                    <div className="c_icon">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/gif-file.png"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="div-block-183 mob_h">
                                                    <div className="c_icon">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/poll_1poll.png"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="div-block-183">
                                                    <div className="c_icon">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/happy_1happy.png"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="div-block-183 mob_h">
                                                    <div className="c_icon">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/calendar_1calendar.png"
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="div-block-183">
                                                    <div className="c_icon">
                                                      <img
                                                        alt=""
                                                        className="f-i"
                                                        loading="lazy"
                                                        src="images/location_1location.png"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="div-block-186">
                                                  <div>Post</div>
                                                </div>
                                              </div>
                                              <div className="w-form-done">
                                                <div>
                                                  Thank you! Your submission has
                                                  been received!
                                                </div>
                                              </div>
                                              <div className="w-form-fail">
                                                <div>
                                                  Oops! Something went wrong
                                                  while submitting the form.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box">
                                        <div className="f_pfp">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/t6.jpg"
                                          />
                                          <div className="div-block-180">
                                            <div className="div-block-179">
                                              <div className="text-block-118">
                                                Jean Long
                                              </div>
                                              <div className="text-block-119">
                                                @jeanlong{' '}
                                                <span className="text-span-6">
                                                  •
                                                </span>{' '}
                                                1h
                                              </div>
                                              <div className="div-block-181">
                                                <img
                                                  alt=""
                                                  className="image-82"
                                                  loading="lazy"
                                                  src="images/menu-1_1menu-1.png"
                                                />
                                                <div className="div-block-193">
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/delete-friend.png"
                                                      srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Unfollow @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/mute.png"
                                                      srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Mute @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/blocked.png"
                                                      srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Block @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/coding.png"
                                                      srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Embed Post
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              100 Days of Code: The Complete{' '}
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/Python?src=hashtag_click"
                                              >
                                                #Python
                                              </a>{' '}
                                              Pro{' '}
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/Bootcamp?src=hashtag_click"
                                              >
                                                #Bootcamp
                                              </a>{' '}
                                              for 2022
                                              <br />
                                              <br />
                                              Master{' '}
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/Python?src=hashtag_click"
                                              >
                                                #Python
                                              </a>{' '}
                                              by building 100 projects in 100
                                              days. Learn data science,
                                              automation, build websites, games
                                              and apps!
                                              <br />
                                              <br />‍
                                              <a
                                                className="tag"
                                                href="https://t.co/2rhmVBeKQ1"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                              >
                                                https://ibl-skills-v3.webflow.io/course
                                                <br />‍
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/online?src=hashtag_click"
                                              >
                                                #online{' '}
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/courses?src=hashtag_click"
                                              >
                                                #courses{' '}
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/onlinecourses?src=hashtag_click"
                                              >
                                                #onlinecourses{' '}
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/100daysofcode?src=hashtag_click"
                                              >
                                                #100daysofcode
                                              </a>
                                              <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                <br />
                                              </a>
                                            </div>
                                            <div className="f-content">
                                              <img
                                                alt=""
                                                className="image-83"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 1279px) 512px, 500px"
                                                src="images/x.jpg"
                                                srcset="images/x-p-500.jpg 500w, images/x-p-800.jpg 800w, images/x-p-1080.jpg 1080w, images/x.jpg 1280w"
                                              />
                                            </div>
                                            <div className="f-tools">
                                              <div className="div-block-182 c-block">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/message_1message.png"
                                                />
                                                <div className="text-block-121">
                                                  210
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/repost_1repost.png"
                                                />
                                                <div className="text-block-121">
                                                  1,242
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/heart_1heart.png"
                                                />
                                                <div className="text-block-121">
                                                  1.4k
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/upload_2upload.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box">
                                        <div className="f_pfp">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                          />
                                          <div className="div-block-180">
                                            <div className="div-block-179">
                                              <div className="text-block-118">
                                                Waqar Phelps
                                              </div>
                                              <div className="text-block-119">
                                                @wagar_phelps{' '}
                                                <span className="text-span-6">
                                                  •
                                                </span>{' '}
                                                2h
                                              </div>
                                              <div className="div-block-181">
                                                <img
                                                  alt=""
                                                  className="image-82"
                                                  loading="lazy"
                                                  src="images/menu-1_1menu-1.png"
                                                />
                                                <div className="div-block-193">
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/delete-friend.png"
                                                      srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Unfollow @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/mute.png"
                                                      srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Mute @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/blocked.png"
                                                      srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Block @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/coding.png"
                                                      srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Embed Post
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              Clearest picture of Mercury ever
                                              taken | NASA
                                              <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                <br />
                                              </a>
                                            </div>
                                            <div className="f-content">
                                              <img
                                                alt=""
                                                className="image-83"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 1279px) 512px, 500px"
                                                src="images/FX9LHFZWQAYvR5L.jpeg"
                                                srcset="images/FX9LHFZWQAYvR5L-p-500.jpeg 500w, images/FX9LHFZWQAYvR5L-p-800.jpeg 800w, images/FX9LHFZWQAYvR5L-p-1080.jpeg 1080w, images/FX9LHFZWQAYvR5L.jpeg 1440w"
                                              />
                                            </div>
                                            <div className="f-tools">
                                              <div className="div-block-182 c-block">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/message_1message.png"
                                                />
                                                <div className="text-block-121">
                                                  350
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/repost_1repost.png"
                                                />
                                                <div className="text-block-121">
                                                  5,493
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/heart-1_1heart-1.png"
                                                />
                                                <div className="text-block-121 liked">
                                                  51.2k
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/upload_2upload.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box last">
                                        <div className="f_pfp">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                          />
                                          <div className="div-block-180">
                                            <div className="div-block-179">
                                              <div className="text-block-118">
                                                Cooper Devlin
                                              </div>
                                              <div className="text-block-119">
                                                @cooperDevlin{' '}
                                                <span className="text-span-6">
                                                  •
                                                </span>{' '}
                                                3h
                                              </div>
                                              <div className="div-block-181">
                                                <img
                                                  alt=""
                                                  className="image-82"
                                                  loading="lazy"
                                                  src="images/menu-1_1menu-1.png"
                                                />
                                                <div className="div-block-193">
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/delete-friend.png"
                                                      srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Unfollow @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/mute.png"
                                                      srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Mute @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/blocked.png"
                                                      srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Block @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/coding.png"
                                                      srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Embed Post
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              Hello everyone! You can now
                                              checkout my course: RESTful API
                                              Server in Nodejs, available at IBL
                                              Skills!
                                            </div>
                                            <div>
                                              <br />‍
                                              <a
                                                className="tag"
                                                href="https://t.co/2rhmVBeKQ1"
                                                rel="noopener noreferrer"
                                                target="_blank"
                                              >
                                                https://ibl-skills-v2.webflow.io/course
                                                <br />‍
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/online?src=hashtag_click"
                                              >
                                                #Javascript{' '}
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/courses?src=hashtag_click"
                                              >
                                                #Development
                                              </a>
                                              <a
                                                className="tag"
                                                href="https://twitter.com/hashtag/onlinecourses?src=hashtag_click"
                                              >
                                                ‍
                                              </a>
                                              <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                <br />
                                              </a>
                                            </div>
                                            <div className="f-content">
                                              <img
                                                alt=""
                                                className="image-83"
                                                loading="lazy"
                                                sizes="(max-width: 479px) 100vw, (max-width: 1279px) 512px, 500px"
                                                src="images/c8.jpg"
                                                srcset="images/c8-p-500.jpeg 500w, images/c8-p-1080.jpeg 1080w, images/c8-p-1600.jpeg 1600w, images/c8-p-2000.jpeg 2000w, images/c8-p-2600.jpeg 2600w, images/c8-p-3200.jpeg 3200w, images/c8.jpg 4288w"
                                              />
                                            </div>
                                            <div className="f-tools">
                                              <div className="div-block-182 c-block">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/message_1message.png"
                                                />
                                                <div className="text-block-121">
                                                  350
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/repost_1repost.png"
                                                />
                                                <div className="text-block-121">
                                                  5,493
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/heart-1_1heart-1.png"
                                                />
                                                <div className="text-block-121 liked">
                                                  51.2k
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/upload_2upload.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box">
                                        <div className="f_pfp show_all">
                                          <a
                                            className="link-7"
                                            href="https://ibl-skills-v2.webflow.io/social?s=mf"
                                          >
                                            Show All Posts
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m sp"
                                  data-name="discussion"
                                >
                                  <div className="feed-panels fh">
                                    <div
                                      className="feed-wr social-page active fh"
                                      data-name="explore"
                                    >
                                      <div className="div-block-250 fh">
                                        <div className="div-block-252">
                                          <div className="text-block-156 top">
                                            Discussion
                                          </div>
                                          <div className="text-block-156">
                                            Coming Soon
                                          </div>
                                          <div className="div-block-251">
                                            <img
                                              alt=""
                                              className="image-29"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 0px, 100vw"
                                              src="images/5825572_56560.png"
                                              srcset="images/5825572_56560-p-500.png 500w, images/5825572_56560-p-800.png 800w, images/5825572_56560-p-1080.png 1080w, images/5825572_56560-p-1600.png 1600w, images/5825572_56560-p-2000.png 2000w, images/5825572_56560-p-2600.png 2600w, images/5825572_56560.png 3132w"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m sp"
                                  data-name="teams"
                                >
                                  <div className="feed-panels fh">
                                    <div
                                      className="feed-wr social-page active fh"
                                      data-name="explore"
                                    >
                                      <div className="div-block-250 fh">
                                        <div className="div-block-252">
                                          <div className="text-block-156 top">
                                            Teams
                                          </div>
                                          <div className="text-block-156">
                                            Coming Soon
                                          </div>
                                          <div className="div-block-251">
                                            <img
                                              alt=""
                                              className="image-29"
                                              loading="lazy"
                                              sizes="(max-width: 479px) 0px, 100vw"
                                              src="images/5825572_56560.png"
                                              srcset="images/5825572_56560-p-500.png 500w, images/5825572_56560-p-800.png 800w, images/5825572_56560-p-1080.png 1080w, images/5825572_56560-p-1600.png 1600w, images/5825572_56560-p-2000.png 2000w, images/5825572_56560-p-2600.png 2600w, images/5825572_56560.png 3132w"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m"
                                  data-name="explore"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page active"
                                      data-name="explore"
                                    >
                                      <div className="div-block-195">
                                        <div className="div-block-196">
                                          <img
                                            alt=""
                                            className="image-85"
                                            loading="lazy"
                                            sizes="(max-width: 479px) 0px, 100vw"
                                            src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                            srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                          />
                                        </div>
                                        <div className="div-block-197">
                                          <div>
                                            <div className="text-block-126 t3">
                                              Top Three Courses
                                            </div>
                                          </div>
                                          <div className="div-block-198">
                                            <div className="ht">
                                              <a className="htl" href="#">
                                                #PythonFundamentals
                                              </a>
                                            </div>
                                            <div className="ht">
                                              <a className="htl" href="#">
                                                #OpenAIChat
                                              </a>
                                            </div>
                                            <div className="ht">
                                              <a className="htl" href="#">
                                                #NewCloud
                                              </a>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box trends">
                                        <div className="text-block-127">
                                          Trending Channels
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              In Development
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                #Python
                                              </a>
                                            </div>
                                            <div className="text-block-128">
                                              2,042 Interactions
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              In Business
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                Accounting
                                              </a>
                                            </div>
                                            <div className="text-block-128">
                                              1,521 Interactions
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              In Finance
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                #Econometrics
                                              </a>
                                            </div>
                                            <div className="text-block-128">
                                              2,145 Interactions
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              In Marketing
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                #Copywriting
                                              </a>
                                            </div>
                                            <div className="text-block-128">
                                              1,344 Interactions
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              In Design
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                #HTML
                                              </a>
                                            </div>
                                            <div className="text-block-128">
                                              1,571 Interactions
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <a
                                          className="show_more_row w-inline-block"
                                          href="#"
                                        >
                                          <div>Show More</div>
                                        </a>
                                      </div>
                                      <div className="feed-box trends">
                                        <div className="text-block-127">
                                          Find the Latest
                                        </div>
                                        <div className="trending_row">
                                          <div className="wh">
                                            <div className="text-block-128">
                                              Course
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                Python for AI
                                              </a>
                                              <br />
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div className="wh">
                                            <div className="text-block-128">
                                              Pathway
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                Languages for Machine Learning
                                              </a>
                                              <br />
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div className="wh">
                                            <div className="text-block-128">
                                              Education
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                Financial Markets
                                              </a>
                                              <br />
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <div className="trending_row">
                                          <div>
                                            <div className="text-block-128">
                                              Course
                                            </div>
                                            <div>
                                              <a className="htg" href="#">
                                                Blockchain Technologies
                                              </a>
                                              <br />
                                            </div>
                                          </div>
                                          <div>
                                            <img
                                              alt=""
                                              className="image-82"
                                              loading="lazy"
                                              src="images/menu-1_1menu-1.png"
                                            />
                                          </div>
                                        </div>
                                        <a
                                          className="show_more_row w-inline-block"
                                          href="#"
                                        >
                                          <div>Show More</div>
                                        </a>
                                      </div>
                                      <div className="feed-box last">
                                        <div className="div-block-199">
                                          <img
                                            alt=""
                                            className="image-86"
                                            loading="lazy"
                                            src="images/messenger_2messenger.png"
                                          />
                                          <div className="text-block-127 highlited_hashtag">
                                            Conversations
                                          </div>
                                          <img
                                            alt=""
                                            className="image-82 m_r"
                                            loading="lazy"
                                            src="images/menu-1_1menu-1.png"
                                          />
                                        </div>
                                        <div className="f_pfp">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                          />
                                          <div className="div-block-180">
                                            <div className="div-block-179">
                                              <div className="text-block-118">
                                                Cooper Devlin
                                              </div>
                                              <div className="text-block-119">
                                                @cooperDevlin{' '}
                                                <span className="text-span-6">
                                                  •
                                                </span>{' '}
                                                3h
                                              </div>
                                              <div className="div-block-181">
                                                <img
                                                  alt=""
                                                  className="image-82"
                                                  loading="lazy"
                                                  src="images/menu-1_1menu-1.png"
                                                />
                                                <div className="div-block-193">
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/delete-friend.png"
                                                      srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Unfollow @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/mute.png"
                                                      srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Mute @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/blocked.png"
                                                      srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Block @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/coding.png"
                                                      srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Embed Post
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              Hello everyone! The new python
                                              course is awesome!{' '}
                                              <span className="tag">
                                                #Python
                                              </span>
                                            </div>
                                            <div className="f-tools">
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/message_1message.png"
                                                />
                                                <div className="text-block-121">
                                                  350
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/repost_1repost.png"
                                                />
                                                <div className="text-block-121">
                                                  5,493
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/heart_1heart.png"
                                                />
                                                <div className="text-block-121">
                                                  51.2k
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/upload_2upload.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box last">
                                        <div className="f_pfp">
                                          <img
                                            alt=""
                                            className="image-4 feed"
                                            loading="lazy"
                                            src="images/t6.jpg"
                                          />
                                          <div className="div-block-180">
                                            <div className="div-block-179">
                                              <div className="text-block-118">
                                                Gillian Gray
                                              </div>
                                              <div className="text-block-119">
                                                @gillian{' '}
                                                <span className="text-span-6">
                                                  •
                                                </span>{' '}
                                                5h
                                              </div>
                                              <div className="div-block-181">
                                                <img
                                                  alt=""
                                                  className="image-82"
                                                  loading="lazy"
                                                  src="images/menu-1_1menu-1.png"
                                                />
                                                <div className="div-block-193">
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/delete-friend.png"
                                                      srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Unfollow @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/mute.png"
                                                      srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Mute @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/blocked.png"
                                                      srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Block @jeanlong
                                                    </div>
                                                  </div>
                                                  <div className="div-block-194">
                                                    <img
                                                      alt=""
                                                      className="f-i tw_im"
                                                      loading="lazy"
                                                      sizes="(max-width: 479px) 0px, 100vw"
                                                      src="images/coding.png"
                                                      srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                      width={20}
                                                    />
                                                    <div className="text-block-123">
                                                      Embed Post
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div>
                                              Just finish the new{' '}
                                              <span className="tag">
                                                #python
                                              </span>{' '}
                                              course. This is great!
                                              <span className="tag"></span>
                                            </div>
                                            <div className="f-tools">
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/message_1message.png"
                                                />
                                                <div className="text-block-121">
                                                  350
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/repost_1repost.png"
                                                />
                                                <div className="text-block-121">
                                                  5,493
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/heart_1heart.png"
                                                />
                                                <div className="text-block-121">
                                                  51.2k
                                                </div>
                                              </div>
                                              <div className="div-block-182">
                                                <img
                                                  alt=""
                                                  className="image-84"
                                                  loading="lazy"
                                                  src="images/upload_2upload.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="feed-box trends">
                                        <div className="div-block-199 mg_b0">
                                          <div className="div-block-200">
                                            <img
                                              alt=""
                                              className="image-86 mg_r0"
                                              loading="lazy"
                                              src="images/messenger_1messenger.png"
                                            />
                                          </div>
                                          <div>
                                            <div>#Python</div>
                                            <div className="text-block-128">
                                              Course
                                            </div>
                                          </div>
                                          <div className="div-block-201">
                                            <div className="text-block-129">
                                              Following
                                              <span className="tag"></span>
                                            </div>
                                          </div>
                                        </div>
                                        <a
                                          className="show_more_row w-inline-block"
                                          href="#"
                                        >
                                          <div>Show More</div>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m messages"
                                  data-name="messages"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page active message"
                                      data-name="home"
                                    >
                                      <div className="message_div">
                                        <div className="feed-box ns messages">
                                          <div className="text-block-130">
                                            Messages
                                          </div>
                                          <div className="div-block-202">
                                            <div className="div-block-203">
                                              <img
                                                alt=""
                                                className="f-i s"
                                                loading="lazy"
                                                src="images/settings_1settings.png"
                                                width={20}
                                              />
                                            </div>
                                            <div className="div-block-203 new_message">
                                              <img
                                                alt=""
                                                className="f-i s"
                                                loading="lazy"
                                                src="images/new-message_1new-message.png"
                                                width={20}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div>
                                          <div className="div-block-205">
                                            <div className="form-block msg_search w-form">
                                              <form
                                                className="form msg_search"
                                                data-name="Email Form"
                                                data-wf-element-id="b38a1ade-1dfd-96f8-5281-01a1ee36a07b"
                                                data-wf-page-id="6596e21ac435cac3c66baaee"
                                                id="email-form"
                                                method="get"
                                                name="email-form"
                                              >
                                                <div className="div-block-204">
                                                  <div className="div-block">
                                                    <img
                                                      alt=""
                                                      className="image-2"
                                                      loading="lazy"
                                                      src="images/magnifying-glass_1magnifying-glass.png"
                                                    />
                                                  </div>
                                                  <input
                                                    className="text-field n_text search w-input"
                                                    data-name="Email 8"
                                                    id="email-8"
                                                    maxLength={256}
                                                    name="email-8"
                                                    placeholder="Search Direct Messages"
                                                    required=""
                                                    type="email"
                                                  />
                                                </div>
                                              </form>
                                              <div className="w-form-done">
                                                <div>
                                                  Thank you! Your submission has
                                                  been received!
                                                </div>
                                              </div>
                                              <div className="w-form-fail">
                                                <div>
                                                  Oops! Something went wrong
                                                  while submitting the form.
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="tw_r active">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/t6.jpg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div className="text-block-118">
                                                  Jean Long
                                                </div>
                                                <div className="text-block-119">
                                                  @jeanlong{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  4m
                                                </div>
                                              </div>
                                              <div className="text-block-131">
                                                Ok great. I just did!{' '}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="tw_r">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div className="text-block-118">
                                                  Cooper Devlin
                                                </div>
                                                <div className="text-block-119">
                                                  @cooperDevlin{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  1h
                                                </div>
                                              </div>
                                              <div className="text-block-131">
                                                Awesome!
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="tw_r">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div className="text-block-118">
                                                  Annabell Gillespie
                                                </div>
                                                <div className="text-block-119">
                                                  @anabell{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  2h
                                                </div>
                                              </div>
                                              <div className="text-block-131">
                                                I literally started crying! That
                                                was perfect!
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="chat_div mobile_hidden">
                                        <div className="div-block-221 message">
                                          <div className="div-block-222 show_msg_div msg">
                                            <img
                                              alt=""
                                              className="image-89"
                                              loading="lazy"
                                              src="images/arrow_1arrow.png"
                                            />
                                          </div>
                                          <img
                                            alt=""
                                            className="image-4 feed chat_img msg_img"
                                            loading="lazy"
                                            src="images/t6.jpg"
                                          />
                                          <div>
                                            <div className="text-block-118 bg">
                                              Jean Long
                                            </div>
                                            <div className="text-block-119 mg_r0 sm">
                                              @jeanlong
                                            </div>
                                          </div>
                                        </div>
                                        <div className="user-info">
                                          <div className="div-block-179 t_r">
                                            <div className="text-block-118">
                                              Jean Long
                                            </div>
                                            <div className="text-block-119">
                                              @jeanlong
                                            </div>
                                          </div>
                                          <div className="text-block-132">
                                            Sharing things I'm learning through
                                            my work and other interests.{' '}
                                            <span className="tag">#Python</span>{' '}
                                            teacher
                                          </div>
                                          <div className="div-block-206">
                                            <div className="text-block-133">
                                              882{' '}
                                              <span className="text-span-7">
                                                Following
                                              </span>
                                            </div>
                                            <div className="text-block-133">
                                              912{' '}
                                              <span className="text-span-7">
                                                Followers
                                              </span>
                                            </div>
                                          </div>
                                          <div className="div-block-207">
                                            <img
                                              alt=""
                                              className="f-i s cal"
                                              loading="lazy"
                                              src="images/calendar_2calendar.png"
                                              width={20}
                                            />
                                            <div className="text-block-134">
                                              Joined February 2018
                                            </div>
                                          </div>
                                        </div>
                                        <div className="div-block-208">
                                          <div className="chat_row">
                                            <div className="c_p_l m">
                                              <div className="c_cloud me">
                                                <div className="me">
                                                  Hello Jean. Can you please let
                                                  me know when should I sent you
                                                  the homework?
                                                </div>
                                              </div>
                                              <div className="c-top">
                                                <div className="text-block-25">
                                                  7:31 PM
                                                </div>
                                                <div className="div-block-209">
                                                  <img
                                                    alt=""
                                                    className="f-i s read"
                                                    loading="lazy"
                                                    src="images/check-7_1check-7.png"
                                                    width={20}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="chat_row"></div>
                                          <div className="chat_row">
                                            <div className="div-block-210">
                                              <img
                                                alt=""
                                                className="image-4 feed chat_img"
                                                loading="lazy"
                                                src="images/t6.jpg"
                                              />
                                              <div>
                                                <div className="c_p_l">
                                                  <div className="c_cloud user">
                                                    <div>Hi Ashley!</div>
                                                  </div>
                                                </div>
                                                <div className="c_p_l">
                                                  <div className="c_cloud user last">
                                                    <div>
                                                      If you have not turned in
                                                      last night's homework
                                                      already, please do so now.
                                                    </div>
                                                  </div>
                                                  <div className="c-top">
                                                    <div className="text-block-25">
                                                      9:02 PM
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="chat_row">
                                            <div className="c_p_l m">
                                              <div className="c_cloud me">
                                                <div className="me">
                                                  Ok great. I just did!{' '}
                                                </div>
                                              </div>
                                              <div className="c-top">
                                                <div className="text-block-25">
                                                  10:08 AM
                                                </div>
                                                <div className="div-block-209">
                                                  <img
                                                    alt=""
                                                    className="f-i s read"
                                                    loading="lazy"
                                                    src="images/check-7_1check-7.png"
                                                    width={20}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="send_chat">
                                          <div className="div-block-211">
                                            <div className="div-block-183">
                                              <div className="c_icon">
                                                <img
                                                  alt=""
                                                  className="f-i"
                                                  loading="lazy"
                                                  src="images/image-1_1image-1.png"
                                                />
                                              </div>
                                            </div>
                                            <div className="div-block-183">
                                              <div className="c_icon">
                                                <img
                                                  alt=""
                                                  className="f-i"
                                                  loading="lazy"
                                                  src="images/gif-file.png"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="form-block send_msg w-form">
                                            <form
                                              className="form msg_search send_msg"
                                              data-name="Email Form"
                                              data-wf-element-id="7df221e3-119a-9983-2956-3dc6ef160542"
                                              data-wf-page-id="6596e21ac435cac3c66baaee"
                                              id="email-form"
                                              method="get"
                                              name="email-form"
                                            >
                                              <div className="div-block-204 send_msg">
                                                <input
                                                  className="text-field n_text search send_msg w-input"
                                                  data-name="Email 8"
                                                  id="email-8"
                                                  maxLength={256}
                                                  name="email-8"
                                                  placeholder="Start a new message"
                                                  required=""
                                                  type="email"
                                                />
                                                <div className="div-block">
                                                  <img
                                                    alt=""
                                                    className="image-2 send_msg"
                                                    loading="lazy"
                                                    src="images/happy_1happy.png"
                                                  />
                                                </div>
                                              </div>
                                            </form>
                                            <div className="w-form-done">
                                              <div>
                                                Thank you! Your submission has
                                                been received!
                                              </div>
                                            </div>
                                            <div className="w-form-fail">
                                              <div>
                                                Oops! Something went wrong while
                                                submitting the form.
                                              </div>
                                            </div>
                                          </div>
                                          <div className="div-block-183 send_msg">
                                            <div className="c_icon">
                                              <img
                                                alt=""
                                                className="f-i send_msg disabled"
                                                loading="lazy"
                                                src="images/send_1send.png"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m"
                                  data-name="following"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page following active"
                                      data-name="following"
                                    >
                                      <div className="div-block-221">
                                        <div className="div-block-222 follow_tabs_back">
                                          <img
                                            alt=""
                                            className="image-89"
                                            loading="lazy"
                                            src="images/arrow_1arrow.png"
                                          />
                                        </div>
                                        <div>
                                          <div className="text-block-118 bg">
                                            Ashley Miller
                                          </div>
                                          <div className="text-block-119 mg_r0 sm">
                                            @ashley
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-219">
                                        <div className="div-block-220">
                                          <div className="follow_tab active">
                                            Following
                                          </div>
                                        </div>
                                        <div className="div-block-220">
                                          <div
                                            className="follow_tab"
                                            data-name="followers"
                                          >
                                            Followers
                                          </div>
                                        </div>
                                      </div>
                                      <div className="no-following">
                                        <div className="div-block-230">
                                          <div className="text-block-142">
                                            You are not following any account
                                          </div>
                                          <div className="text-block-143">
                                            Following accounts is an easy way to
                                            curate your timeline and know what’s
                                            happening with the topics and people
                                            you’re interested in.
                                          </div>
                                          <div className="div-block-186 fol">
                                            <div className="text-block-144">
                                              Find People to Follow
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="following_list">
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/t6.jpg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Jean Long
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @jeanlong
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Sharing things I'm learning
                                                through my work and other
                                                interests.{' '}
                                                <span className="tag">
                                                  #Python
                                                </span>{' '}
                                                teacher
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Piers Horne
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @piers
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Internet scholar. Web
                                                evangelist. Entrepreneur.
                                                Professional travel advocate.
                                                Devoted organizer. General
                                                writer. Hardcore coffee ninja.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Harlow Hulme
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @harlow
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Food practitioner. Student.
                                                Twitter expert. Friendly
                                                introvert. Hipster-friendly
                                                bacon fanatic.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Roxie Daniel
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @roxie
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Introvert. Gamer. Bacon
                                                advocate. Coffee practitioner.
                                                Beer fan. Hardcore internet
                                                buff. Avid tv scholar.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Dylon Cortez
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @dylon
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Travel fan. Wannabe pop culture
                                                practitioner. Problem solver.
                                                Reader. Gamer. Troublemaker.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-13-at-7.57.02-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Edan Hebert
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @edan
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Food lover. Troublemaker. Bacon
                                                expert. Coffee trailblazer.
                                                Analyst. Zombie fanatic. Social
                                                media nerd. Music enthusiast.
                                                Devoted web fan.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-13-at-7.58.22-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Zainab Hirst
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @zainab
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Travel junkie. Gamer. Pop
                                                culture aficionado. Food guru.
                                                Internet fanatic. Communicator.
                                                Social media advocate. Tv geek.
                                                Bacon nerd.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m"
                                  data-name="followers"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page following active"
                                      data-name="following"
                                    >
                                      <div className="div-block-221">
                                        <div className="div-block-222 follow_tabs_back">
                                          <img
                                            alt=""
                                            className="image-89"
                                            loading="lazy"
                                            src="images/arrow_1arrow.png"
                                          />
                                        </div>
                                        <div>
                                          <div className="text-block-118 bg">
                                            Ashley Miller
                                          </div>
                                          <div className="text-block-119 mg_r0 sm">
                                            @ashley
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-219">
                                        <div className="div-block-220">
                                          <div
                                            className="follow_tab"
                                            data-name="following"
                                          >
                                            Following
                                          </div>
                                        </div>
                                        <div className="div-block-220">
                                          <div className="follow_tab active">
                                            Followers
                                          </div>
                                        </div>
                                      </div>
                                      <div className="following_list">
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-14-at-8.16.20-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Neve Holman
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @neve
                                                  </div>
                                                </div>
                                                <div className="div-block-218 f_back">
                                                  <div>Follow Back</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Sharing things I'm learning
                                                through my work and other
                                                interests.{' '}
                                                <span className="tag">
                                                  #Python
                                                </span>{' '}
                                                teacher
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/150-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Lennon Melton
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @lennon
                                                  </div>
                                                </div>
                                                <div className="div-block-218 f_back">
                                                  <div>Follow Back</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Introvert. Gamer. Bacon
                                                advocate. Coffee practitioner.
                                                Beer fan. Hardcore internet
                                                buff. Avid tv scholar.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/150.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Kaylum Barr
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @kaylum
                                                  </div>
                                                </div>
                                                <div className="div-block-218 f_back">
                                                  <div>Follow Back</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Internet scholar. Web
                                                evangelist. Entrepreneur.
                                                Professional travel advocate.
                                                Devoted organizer. General
                                                writer. Hardcore coffee ninja.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-14-at-8.16.50-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Ameer Parra
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @ameer
                                                  </div>
                                                </div>
                                                <div className="div-block-218 f_back">
                                                  <div>Follow Back</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Travel fan. Wannabe pop culture
                                                practitioner. Problem solver.
                                                Reader. Gamer. Troublemaker.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-13-at-7.58.22-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Zainab Hirst
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @zainab
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Travel junkie. Gamer. Pop
                                                culture aficionado. Food guru.
                                                Internet fanatic. Communicator.
                                                Social media advocate. Tv geek.
                                                Bacon nerd.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/150-2.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Cora Powell
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @cora
                                                  </div>
                                                </div>
                                                <div className="div-block-218 f_back">
                                                  <div>Follow Back</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Food practitioner. Student.
                                                Twitter expert. Friendly
                                                introvert. Hipster-friendly
                                                bacon fanatic.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                        <div className="tw_r follow_box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/Screenshot-2022-09-14-at-8.19.12-PM.png"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179 t_r">
                                                <div>
                                                  <div className="text-block-118">
                                                    Glen Hodges
                                                  </div>
                                                  <div className="text-block-119 mg_r0">
                                                    @glen
                                                  </div>
                                                </div>
                                                <div className="div-block-218">
                                                  <div>Following</div>
                                                </div>
                                              </div>
                                              <div className="text-block-137">
                                                Food lover. Troublemaker. Bacon
                                                expert. Coffee trailblazer.
                                                Analyst. Zombie fanatic. Social
                                                media nerd. Music enthusiast.
                                                Devoted web fan.
                                              </div>
                                            </div>
                                          </div>
                                          <img
                                            alt=""
                                            className="cancel_dc c_i user_tick"
                                            loading="lazy"
                                            src="images/check-7_1check-7.png"
                                            width={13}
                                          />
                                        </div>
                                      </div>
                                      <div className="no-followers">
                                        <div className="div-block-230">
                                          <img
                                            alt=""
                                            className="image-92"
                                            loading="lazy"
                                            sizes="(max-width: 479px) 0px, 100vw"
                                            src="images/1166881.png"
                                            srcset="images/1166881-p-500.png 500w, images/1166881-p-800.png 800w, images/1166881-p-1080.png 1080w, images/1166881-p-1600.png 1600w, images/1166881-p-2000.png 2000w, images/1166881-p-2600.png 2600w, images/1166881-p-3200.png 3200w"
                                          />
                                          <div className="text-block-142">
                                            You do not have any followers
                                          </div>
                                          <div className="text-block-143">
                                            When someone follows this account,
                                            they’ll show up here. Tweeting and
                                            interacting with others helps boost
                                            followers.
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="feed_cont al-m"
                                  data-name="profile"
                                >
                                  <div className="feed-panels">
                                    <div
                                      className="feed-wr social-page following active"
                                      data-name="following"
                                    >
                                      <div className="div-block-221">
                                        <div className="div-block-222 follow_tabs_back">
                                          <img
                                            alt=""
                                            className="image-89"
                                            loading="lazy"
                                            src="images/arrow_1arrow.png"
                                          />
                                        </div>
                                        <div>
                                          <div className="text-block-118 bg">
                                            Ashley Miller
                                          </div>
                                          <div
                                            className="text-block-119 mg_r0 sm profile_text active"
                                            data-name="posts"
                                          >
                                            3 Posts
                                          </div>
                                          <div
                                            className="text-block-119 mg_r0 sm profile_text"
                                            data-name="posts_replies"
                                          >
                                            5 Posts
                                          </div>
                                          <div
                                            className="text-block-119 mg_r0 sm profile_text"
                                            data-name="media"
                                          >
                                            2 Photo &amp; Images
                                          </div>
                                          <div
                                            className="text-block-119 mg_r0 sm profile_text"
                                            data-name="likes"
                                          >
                                            3 Likes
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-223">
                                        <img
                                          alt=""
                                          className="image-90 sp"
                                          loading="lazy"
                                          sizes="(max-width: 479px) 0px, 100vw"
                                          src="images/shapelined-_JBKdviweXI-unsplash.jpg"
                                          srcset="images/shapelined-_JBKdviweXI-unsplash-p-500.jpeg 500w, images/shapelined-_JBKdviweXI-unsplash-p-800.jpeg 800w, images/shapelined-_JBKdviweXI-unsplash-p-1080.jpeg 1080w, images/shapelined-_JBKdviweXI-unsplash-p-1600.jpeg 1600w, images/shapelined-_JBKdviweXI-unsplash-p-2000.jpeg 2000w, images/shapelined-_JBKdviweXI-unsplash.jpg 2400w"
                                        />
                                        <div className="div-block-111 social_profile">
                                          <div className="div-block-39">
                                            <img
                                              alt=""
                                              className="image-23 soc_img"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="div-block-224">
                                        <div className="div-block-227">
                                          <div className="div-block-226">
                                            <div className="text-block-140">
                                              Edit Profile
                                            </div>
                                          </div>
                                        </div>
                                        <div className="text-block-138">
                                          Ashley Miller
                                        </div>
                                        <div className="text-block-119 mg_l0">
                                          @ashley
                                        </div>
                                        <div className="div-block-225">
                                          <img
                                            alt=""
                                            className="image-91"
                                            loading="lazy"
                                            src="images/calendar_2calendar.png"
                                          />
                                          <div className="text-block-119 mg_l0 joined_dext">
                                            Joined September 2021
                                          </div>
                                        </div>
                                      </div>
                                      <div className="followers_text pp social_f">
                                        <div
                                          className="text-block-139"
                                          data-name="followers"
                                          data-w-id="28ac6bdd-95cc-e5f9-adc5-eaaa8d46cbc8"
                                        >
                                          <span className="text-span-8">
                                            120
                                          </span>{' '}
                                          Following{' '}
                                        </div>
                                        <div
                                          className="text-block-139"
                                          data-name="followers"
                                          data-w-id="a86b09ff-a1c1-4012-5691-a9ee6fd31213"
                                        >
                                          <span className="text-span-8">
                                            153
                                          </span>{' '}
                                          Followers{' '}
                                        </div>
                                      </div>
                                      <div className="div-block-219 likes">
                                        <div className="div-block-220 prof_tab">
                                          <div
                                            className="likes_tab active"
                                            data-name="posts"
                                          >
                                            Posts
                                          </div>
                                        </div>
                                        <div className="div-block-220 prof_tab">
                                          <div
                                            className="likes_tab"
                                            data-name="posts_replies"
                                          >
                                            Posts &amp; Replies
                                          </div>
                                        </div>
                                        <div className="div-block-220 prof_tab">
                                          <div
                                            className="likes_tab"
                                            data-name="media"
                                          >
                                            Media
                                          </div>
                                        </div>
                                        <div className="div-block-220 prof_tab">
                                          <div
                                            className="likes_tab"
                                            data-name="likes"
                                          >
                                            Likes
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="profile_list active"
                                        data-name="posts"
                                      >
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley Miller
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  2h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Python, Java, and the C family
                                                are still the most popular first
                                                choices for programming, but
                                                backing one of them up with SQL
                                                is a smart move.
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/network-3396348_1280.jpg"
                                                  srcset="images/network-3396348_1280-p-500.jpg 500w, images/network-3396348_1280-p-800.jpg 800w, images/network-3396348_1280-p-1080.jpg 1080w, images/network-3396348_1280.jpg 1280w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley Miller
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  10h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Just curious, are you using
                                                =&gt; functions exclusively or
                                                still sticking to traditional
                                                function syntax? No judgement!
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley Miller
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  12h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Speaking of code editors - Can
                                                we just acknowledge how cool
                                                this editor is?
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/code-944499_1280.jpg"
                                                  srcset="images/code-944499_1280-p-500.jpg 500w, images/code-944499_1280-p-800.jpg 800w, images/code-944499_1280-p-1080.jpg 1080w, images/code-944499_1280.jpg 1280w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="profile_list"
                                        data-name="posts_replies"
                                      >
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  2h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                The best API I've used is the
                                                one I built for a software that
                                                is a hybrid of an E-commerce and
                                                social media application
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <div className="f_pfp reply">
                                                  <img
                                                    alt=""
                                                    className="image-4 feed reply_image"
                                                    loading="lazy"
                                                    src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                                  />
                                                  <div className="div-block-180">
                                                    <div className="div-block-179">
                                                      <div className="text-block-118">
                                                        Cooper Devlin
                                                      </div>
                                                      <div className="text-block-119">
                                                        @cooperDevlin{' '}
                                                        <span className="text-span-6">
                                                          •
                                                        </span>{' '}
                                                        10h
                                                      </div>
                                                    </div>
                                                    <div>
                                                      What's the most
                                                      intuitive/useful/beautifully-functioning
                                                      API you've used recently?
                                                      <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                        <br />
                                                      </a>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  10h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Just curious, are you using
                                                =&gt; functions exclusively or
                                                still sticking to traditional
                                                function syntax? No judgement!
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  12h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Speaking of code editors - Can
                                                we just acknowledge how cool
                                                this editor is?
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/code-944499_1280.jpg"
                                                  srcset="images/code-944499_1280-p-500.jpg 500w, images/code-944499_1280-p-800.jpg 800w, images/code-944499_1280-p-1080.jpg 1080w, images/code-944499_1280.jpg 1280w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="profile_list"
                                        data-name="media"
                                      >
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  2h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Python, Java, and the C family
                                                are still the most popular first
                                                choices for programming, but
                                                backing one of them up with SQL
                                                is a smart move.
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/network-3396348_1280.jpg"
                                                  srcset="images/network-3396348_1280-p-500.jpg 500w, images/network-3396348_1280-p-800.jpg 800w, images/network-3396348_1280-p-1080.jpg 1080w, images/network-3396348_1280.jpg 1280w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Ashley
                                                </div>
                                                <div className="text-block-119">
                                                  @ashley{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  12h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Speaking of code editors - Can
                                                we just acknowledge how cool
                                                this editor is?
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/code-944499_1280.jpg"
                                                  srcset="images/code-944499_1280-p-500.jpg 500w, images/code-944499_1280-p-800.jpg 800w, images/code-944499_1280-p-1080.jpg 1080w, images/code-944499_1280.jpg 1280w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart_1heart.png"
                                                  />
                                                  <div className="text-block-121">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        className="profile_list"
                                        data-name="likes"
                                      >
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Waqar Phelps
                                                </div>
                                                <div className="text-block-119">
                                                  @wagar_phelps{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  2h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Clearest picture of Mercury ever
                                                taken | NASA
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/FX9LHFZWQAYvR5L.jpeg"
                                                  srcset="images/FX9LHFZWQAYvR5L-p-500.jpeg 500w, images/FX9LHFZWQAYvR5L-p-800.jpeg 800w, images/FX9LHFZWQAYvR5L-p-1080.jpeg 1080w, images/FX9LHFZWQAYvR5L.jpeg 1440w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart-1_1heart-1.png"
                                                  />
                                                  <div className="text-block-121 liked">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box last">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Cooper Devlin
                                                </div>
                                                <div className="text-block-119">
                                                  @cooperDevlin{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  3h
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Hello everyone! You can now
                                                checkout my course: RESTful API
                                                Server in Nodejs, available at
                                                IBL Skills!
                                              </div>
                                              <div>
                                                <br />‍
                                                <a
                                                  className="tag"
                                                  href="https://t.co/2rhmVBeKQ1"
                                                  rel="noopener noreferrer"
                                                  target="_blank"
                                                >
                                                  https://ibl-skills-v2.webflow.io/course
                                                  <br />‍
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/online?src=hashtag_click"
                                                >
                                                  #Javascript{' '}
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/courses?src=hashtag_click"
                                                >
                                                  #Development
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/onlinecourses?src=hashtag_click"
                                                >
                                                  ‍
                                                </a>
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/c8.jpg"
                                                  srcset="images/c8-p-500.jpeg 500w, images/c8-p-1080.jpeg 1080w, images/c8-p-1600.jpeg 1600w, images/c8-p-2000.jpeg 2000w, images/c8-p-2600.jpeg 2600w, images/c8-p-3200.jpeg 3200w, images/c8.jpg 4288w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    350
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    5,493
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart-1_1heart-1.png"
                                                  />
                                                  <div className="text-block-121 liked">
                                                    51.2k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="feed-box">
                                          <div className="f_pfp">
                                            <img
                                              alt=""
                                              className="image-4 feed"
                                              loading="lazy"
                                              src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                                            />
                                            <div className="div-block-180">
                                              <div className="div-block-179">
                                                <div className="text-block-118">
                                                  Roxie Daniel
                                                </div>
                                                <div className="text-block-119">
                                                  @roxie{' '}
                                                  <span className="text-span-6">
                                                    •
                                                  </span>{' '}
                                                  Sep 13
                                                </div>
                                                <div className="div-block-181">
                                                  <img
                                                    alt=""
                                                    className="image-82"
                                                    loading="lazy"
                                                    src="images/menu-1_1menu-1.png"
                                                  />
                                                  <div className="div-block-193">
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/delete-friend.png"
                                                        srcset="images/delete-friend-p-500.png 500w, images/delete-friend.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Unfollow @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/mute.png"
                                                        srcset="images/mute-p-500.png 500w, images/mute.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Mute @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/blocked.png"
                                                        srcset="images/blocked-p-500.png 500w, images/blocked.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Block @jeanlong
                                                      </div>
                                                    </div>
                                                    <div className="div-block-194">
                                                      <img
                                                        alt=""
                                                        className="f-i tw_im"
                                                        loading="lazy"
                                                        sizes="(max-width: 479px) 0px, 100vw"
                                                        src="images/coding.png"
                                                        srcset="images/coding-p-500.png 500w, images/coding.png 512w"
                                                        width={20}
                                                      />
                                                      <div className="text-block-123">
                                                        Embed Post
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div>
                                                Interested in learning
                                                Javascript? Check this course
                                                out!{' '}
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div>
                                                <br />‍
                                                <a
                                                  className="tag"
                                                  href="https://t.co/2rhmVBeKQ1"
                                                  rel="noopener noreferrer"
                                                  target="_blank"
                                                >
                                                  https://ibl-skills-v2.webflow.io/course
                                                  <br />‍
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/online?src=hashtag_click"
                                                >
                                                  #Javascript{' '}
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/courses?src=hashtag_click"
                                                >
                                                  #Development
                                                </a>
                                                <a
                                                  className="tag"
                                                  href="https://twitter.com/hashtag/onlinecourses?src=hashtag_click"
                                                >
                                                  ‍
                                                </a>
                                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                                  <br />
                                                </a>
                                              </div>
                                              <div className="f-content">
                                                <img
                                                  alt=""
                                                  className="image-83"
                                                  loading="lazy"
                                                  sizes="(max-width: 479px) 0px, 100vw"
                                                  src="images/burst-kUqqaRjJuw0-unsplash.jpg"
                                                  srcset="images/burst-kUqqaRjJuw0-unsplash-p-500.jpg 500w, images/burst-kUqqaRjJuw0-unsplash.jpg 640w"
                                                />
                                              </div>
                                              <div className="f-tools">
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/message_1message.png"
                                                  />
                                                  <div className="text-block-121">
                                                    210
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/repost_1repost.png"
                                                  />
                                                  <div className="text-block-121">
                                                    1,242
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/heart-1_1heart-1.png"
                                                  />
                                                  <div className="text-block-121 liked">
                                                    1.4k
                                                  </div>
                                                </div>
                                                <div className="div-block-182">
                                                  <img
                                                    alt=""
                                                    className="image-84"
                                                    loading="lazy"
                                                    src="images/upload_2upload.png"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ov_panel" data-name="sh">
                          <div className="results g4">
                            <a
                              className="link-block-7 w-inline-block"
                              href="#"
                              id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c3420-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c3421-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    src="images/c21.jpg"
                                  />
                                  <div className="label c">
                                    <div className="text-block-124">COURSE</div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        sizes="(max-width: 479px) 0px, 100vw"
                                        src="images/google.png"
                                        srcset="images/google-p-500.png 500w, images/google.png 512w"
                                      />
                                    </div>
                                    <div className="text-block-16">Google</div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        130 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Beginner
                                      <strong className="bold-text-2 c">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        20 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 mob w-inline-block"
                              href="book.html"
                              id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c3456-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c3457-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    sizes="(max-width: 479px) 0px, 100vw"
                                    src="images/geometric-gbcbf05bfd_640.jpg"
                                    srcset="images/geometric-gbcbf05bfd_640-p-500.jpeg 500w, images/geometric-gbcbf05bfd_640.jpg 640w"
                                  />
                                  <div className="label">
                                    <div className="text-block-124">
                                      PATHWAY
                                    </div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/ibm.png"
                                      />
                                    </div>
                                    <div className="text-block-16">IBM</div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        120 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 p">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        15 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="article.html"
                              id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c348c-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-_76852a2f-7146-d8bb-4d9f-9196995c348d-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    src="images/7-p-500.jpeg"
                                  />
                                  <div className="label o">
                                    <div className="text-block-124">
                                      Learning Content
                                    </div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/Stanford_Coursera_Logo.png"
                                      />
                                    </div>
                                    <div className="text-block-16">
                                      Stanford University
                                    </div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        10 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 x">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        22 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="article.html"
                            >
                              <div
                                className="item-box"
                                id="w-node-b8ec9782-50f9-057f-d5d3-d8c3103e0aa3-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    sizes="(max-width: 479px) 0px, 100vw"
                                    src="images/c8.jpg"
                                    srcset="images/c8-p-500.jpeg 500w, images/c8-p-1080.jpeg 1080w, images/c8-p-1600.jpeg 1600w, images/c8-p-2000.jpeg 2000w, images/c8-p-2600.jpeg 2600w, images/c8-p-3200.jpeg 3200w, images/c8.jpg 4288w"
                                  />
                                  <div className="label c">
                                    <div className="text-block-124">COURSE</div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/Stanford_Coursera_Logo.png"
                                      />
                                    </div>
                                    <div className="text-block-16">
                                      Stanford University
                                    </div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        10 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 c">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        22 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 mob w-inline-block"
                              href="book.html"
                              id="w-node-_9338e2c0-6598-9443-1ecd-721e65cfa2e7-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-_9338e2c0-6598-9443-1ecd-721e65cfa2e8-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    sizes="(max-width: 479px) 0px, 100vw"
                                    src="images/c7.jpg"
                                    srcset="images/c7-p-1080.jpeg 1080w, images/c7-p-1600.jpeg 1600w, images/c7-p-2000.jpeg 2000w, images/c7-p-2600.jpeg 2600w, images/c7-p-3200.jpeg 3200w, images/c7.jpg 6000w"
                                  />
                                  <div className="label">
                                    <div className="text-block-124">
                                      PATHWAY
                                    </div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/ibm.png"
                                      />
                                    </div>
                                    <div className="text-block-16">IBM</div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        120 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 p">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        15 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="article.html"
                              id="w-node-_5c4b9347-b007-819a-b353-38b8efdbc182-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-_5c4b9347-b007-819a-b353-38b8efdbc183-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    src="images/Screenshot-2020-05-22-at-10.44.38-PM.png"
                                  />
                                  <div className="label o">
                                    <div className="text-block-124">
                                      Learning Content
                                    </div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/Stanford_Coursera_Logo.png"
                                      />
                                    </div>
                                    <div className="text-block-16">
                                      Stanford University
                                    </div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        10 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 x">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        22 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="article.html"
                              id="w-node-b097575e-69db-7cf9-8220-eb467e60a68f-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-b097575e-69db-7cf9-8220-eb467e60a690-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    src="images/c10.jpg"
                                  />
                                  <div className="label">
                                    <div className="text-block-124">
                                      PATHWAY
                                    </div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/Stanford_Coursera_Logo.png"
                                      />
                                    </div>
                                    <div className="text-block-16">
                                      Stanford University
                                    </div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        10 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 p">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        22 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="article.html"
                              id="w-node-cb37aab2-5819-d42b-3c6a-3b248a5fc958-c66baaee"
                            >
                              <div
                                className="item-box"
                                id="w-node-cb37aab2-5819-d42b-3c6a-3b248a5fc959-c66baaee"
                              >
                                <div className="div-block-22">
                                  <img
                                    alt=""
                                    className="image-11"
                                    loading="lazy"
                                    sizes="(max-width: 479px) 0px, 100vw"
                                    src="images/6123cb8af7e1074989c91721_course2.jpeg"
                                    srcset="images/6123cb8af7e1074989c91721_course2-p-500.jpeg 500w, images/6123cb8af7e1074989c91721_course2.jpeg 800w"
                                  />
                                  <div className="label c">
                                    <div className="text-block-124">COURSE</div>
                                  </div>
                                </div>
                                <div className="item-body">
                                  <div className="div-block-23">
                                    <div className="div-block-24">
                                      <img
                                        alt=""
                                        className="image-18"
                                        loading="lazy"
                                        src="images/Stanford_Coursera_Logo.png"
                                      />
                                    </div>
                                    <div className="text-block-16">
                                      Stanford University
                                    </div>
                                    <div className="div-block-28">
                                      <div className="text-block-20">
                                        10 Skill Coins
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-block-9">
                                    Python for Data Science, AI &amp;
                                    Development
                                  </div>
                                  <div className="div-block-25">
                                    <div className="text-block-17">
                                      <span className="skill_span">
                                        Computer Programming
                                      </span>{' '}
                                      <span className="skill_span">
                                        Python Libraries
                                      </span>
                                      <span className="skill_span last">
                                        Python Programming
                                      </span>
                                    </div>
                                  </div>
                                  <div className="div-block-26">
                                    <img
                                      alt=""
                                      className="image-19"
                                      loading="lazy"
                                      sizes="(max-width: 479px) 0px, 100vw"
                                      src="images/Screenshot-2022-06-07-at-7.25.09-PM.png"
                                      srcset="images/Screenshot-2022-06-07-at-7.25.09-PM-p-500.png 500w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-800.png 800w, images/Screenshot-2022-06-07-at-7.25.09-PM-p-1080.png 1080w, images/Screenshot-2022-06-07-at-7.25.09-PM.png 1343w"
                                    />
                                    <div className="text-block-18">(1k+)</div>
                                  </div>
                                  <div className="div-block-27">
                                    <div className="text-block-19">
                                      Advanced
                                      <strong className="bold-text-2 c">
                                        {' '}
                                      </strong>
                                      <span className="bullet">
                                        <strong className="bold-text-2">
                                          •
                                        </strong>
                                      </span>
                                      <strong className="bold-text-2">
                                        {' '}
                                        22 Hours
                                      </strong>
                                    </div>
                                    <div className="item_options">
                                      <div className="item_options_triger">
                                        <img
                                          alt=""
                                          className="image-20"
                                          loading="lazy"
                                          src="images/menu_1menu.png"
                                        />
                                      </div>
                                      <div className="options_div">
                                        <div className="text-block-103">
                                          Add to Pathway
                                        </div>
                                        <div className="text-block-103">
                                          Save for Later
                                        </div>
                                        <div className="text-block-103">
                                          Dismiss
                                        </div>
                                        <div className="text-block-103">
                                          Share
                                        </div>
                                        <div className="text-block-103">
                                          Create a Pathway
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                        <div className="ov_panel" data-name="people">
                          <div className="results g4">
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-_6e0ede65-7e2e-ea4a-58f2-9eb91ef1b152-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_6e0ede65-7e2e-ea4a-58f2-9eb91ef1b153-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/Screenshot-2022-09-13-at-7.58.22-PM.png"
                                />
                                <div className="peoplename">Gail Fletcher</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      Web Developer
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-a1a0adc5-ffae-bbc4-ffce-cadf383df925-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-a1a0adc5-ffae-bbc4-ffce-cadf383df926-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/Screenshot-2022-09-14-at-8.19.12-PM.png"
                                />
                                <div className="peoplename">Cian Hurst</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Arithmetic Operators
                                    </div>
                                    <div className="text-block-152">
                                      Code Review
                                    </div>
                                    <div className="text-block-152">
                                      Conditional Statements
                                    </div>
                                    <div className="text-block-152">
                                      Front End
                                    </div>
                                    <div className="text-block-152">
                                      HTTP Request
                                    </div>
                                    <div className="text-block-152">
                                      Machine Learning
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-a788d152-8e72-20fb-32a4-bd5c17eb5786-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-a788d152-8e72-20fb-32a4-bd5c17eb5787-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/150-2.jpeg"
                                />
                                <div className="peoplename">Rosie Dixon</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Pair Programming
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Machine Learning
                                    </div>
                                    <div className="text-block-152">
                                      Web Developer
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      REST / RESTful
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-_5406c80c-c08e-5feb-d54b-8ba75e6938f8-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_5406c80c-c08e-5feb-d54b-8ba75e6938f9-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/Screenshot-2022-09-14-at-8.16.50-PM.png"
                                />
                                <div className="peoplename">Rupert Hall</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Synchronous Learning
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Tensor Flow
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Version Control
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-d1e24624-aae2-bb34-14b7-07939ac70185-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-d1e24624-aae2-bb34-14b7-07939ac70186-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/150-1.jpeg"
                                />
                                <div className="peoplename">Marissa Roth</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      Version Control
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-_74e55031-48f2-39e7-24b9-06ea9302acf4-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_74e55031-48f2-39e7-24b9-06ea9302acf5-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/150.jpeg"
                                />
                                <div className="peoplename">Keelan Dunn</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Ruby on Rails
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Synchronous Learning
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-_6a7c9841-1781-ea1a-5d9a-d74f16e41489-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_6a7c9841-1781-ea1a-5d9a-d74f16e4148a-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/Screenshot-2022-09-13-at-7.57.02-PM.png"
                                />
                                <div className="peoplename">Huw Nichols</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      Web Developer
                                    </div>
                                    <div className="text-block-152">
                                      Version Control
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 w-inline-block"
                              href="public-profile.html"
                              id="w-node-f498a782-fd06-30c2-06b7-4ac5b2de1e67-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-f498a782-fd06-30c2-06b7-4ac5b2de1e68-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/Screenshot-2022-09-14-at-8.16.20-PM.png"
                                />
                                <div className="peoplename">Orla Kelley</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      React Native
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 hide w-inline-block"
                              href="public-profile.html"
                              id="w-node-_42443c31-aa16-357f-36fc-b30b10c0ae1c-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_42443c31-aa16-357f-36fc-b30b10c0ae1d-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/t6.jpg"
                                />
                                <div className="peoplename">Lana Hill</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      Ruby on Rails
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Synchronous Learning
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 hide w-inline-block"
                              href="public-profile.html"
                              id="w-node-_5ea87267-cdc2-602f-b2c8-9a5d6b620979-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_5ea87267-cdc2-602f-b2c8-9a5d6b62097a-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                                />
                                <div className="peoplename">Taylor Henry</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Tensor Flow
                                    </div>
                                    <div className="text-block-152">
                                      Version Control
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 hide w-inline-block"
                              href="public-profile.html"
                              id="w-node-_89d8de33-7490-1659-9c12-611cde653b9b-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-_89d8de33-7490-1659-9c12-611cde653b9c-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                                />
                                <div className="peoplename">Zach Burke</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Tensor Flow
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Python Libraries
                                    </div>
                                    <div className="text-block-152">
                                      Web Developer
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Java Programming
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                            <a
                              className="link-block-7 hide w-inline-block"
                              href="public-profile.html"
                              id="w-node-b44aa4f3-facc-f21e-0e66-bd9193a429e1-c66baaee"
                            >
                              <div
                                className="item-box people"
                                id="w-node-b44aa4f3-facc-f21e-0e66-bd9193a429e2-c66baaee"
                              >
                                <img
                                  alt=""
                                  className="image-96"
                                  loading="lazy"
                                  src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                                />
                                <div className="peoplename">Anika Lowe</div>
                                <div className="div-block-244">
                                  <img
                                    alt=""
                                    className="image-97"
                                    loading="lazy"
                                    src="images/price-tag_1price-tag.png"
                                  />
                                  <div className="div-block-245">
                                    <div className="text-block-152">
                                      Python Programming,
                                    </div>
                                    <div className="text-block-152">
                                      Computer Programming
                                    </div>
                                    <div className="text-block-152">
                                      Tensor Flow
                                    </div>
                                    <div className="text-block-152">
                                      Ruby on Rails
                                    </div>
                                    <div className="text-block-152">
                                      Back-End Developer
                                    </div>
                                    <div className="text-block-152">
                                      Search Engine
                                    </div>
                                  </div>
                                </div>
                                <div className="div-block-246">
                                  <div className="people-follow">
                                    <div className="text-block-153"></div>
                                    <div className="text-block-154">Follow</div>
                                  </div>
                                </div>
                              </div>
                            </a>
                          </div>
                          <div className="div-block-247">
                            <div className="more_people">
                              <div className="more-text">More</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="welcome_div">
                    <div className="p1">
                      <div className="nav">
                        <div className="nav-cont welcome">
                          <div className="nav-left">
                            <img
                              alt=""
                              className="image welcome"
                              loading="lazy"
                              src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="div-block-78">
                        <div className="div-block-79">
                          <img
                            alt=""
                            className="image-47"
                            loading="lazy"
                            sizes="(max-width: 479px) 0px, 100vw"
                            src="images/Untitled-1.jpg"
                            srcset="images/Untitled-1-p-500.jpeg 500w, images/Untitled-1.jpg 639w"
                          />
                          <div className="div-block-80">
                            <div className="text-block-60">
                              Welcome to IBL Skills
                            </div>
                            <div className="text-block-61">
                              Enjoy the first high-performance, affordable
                              Skills Learning on AWS Marketplace. It will
                              empower you to build —through selected content and
                              a pedagogical method based on machine learning —
                              the right skills you need to boost your career. 
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="welcome_footer">
                        <div className="dots">
                          <div className="div-block-82 active"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                        </div>
                        <div className="div-block-81">
                          <div
                            className="g_s_btn first_btn"
                            data-w-id="e4983720-d1af-91c4-fab3-e55ae43faf72"
                          >
                            <div>Get Started</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p2">
                      <div className="nav">
                        <div className="nav-cont welcome">
                          <div className="nav-left">
                            <img
                              alt=""
                              className="image welcome"
                              loading="lazy"
                              src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="div-block-78">
                        <div className="div-block-84">
                          <div className="text-block-62">
                            First, add or select the skills you want to develop
                          </div>
                          <div className="form-block welcome w-form">
                            <form
                              className="form welcome_f"
                              data-name="Email Form"
                              data-wf-element-id="b509103d-18d1-2175-335e-7d8db8e29760"
                              data-wf-page-id="6596e21ac435cac3c66baaee"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div className="div-block">
                                <img
                                  alt=""
                                  className="image-2"
                                  loading="lazy"
                                  src="images/magnifying-glass_1magnifying-glass.png"
                                />
                              </div>
                              <input
                                className="text-field w-input"
                                data-name="Email 6"
                                id="email-6"
                                maxLength={256}
                                name="email-6"
                                placeholder=""
                                required=""
                                type="email"
                              />
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                          <div className="tx_s">18 Selected Skills</div>
                          <div className="div-block-83">
                            <div className="div-block-17">
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Event Management
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Leadership
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Marketing
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Software Development
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Communication
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Software Project Management
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Local Government
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Social Media Marketing
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Social Commentary
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Feminism
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Socieconomics
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Business Comminications
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Communication Skills
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Computer Skills
                                </div>
                              </div>
                              <div className="div-block-16 welcome">
                                <div className="text-block-12 welcome">
                                  Editing
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Graphic Design
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Information Architecture
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Research
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Socieconomic development
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Software Testing
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Time Management
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Leadership Dallas
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Instructional Design
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Qualitative Research
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Socioeconomic Impact of Female Education
                                </div>
                              </div>
                              <div className="div-block-16 welcome selected">
                                <img
                                  alt=""
                                  className="image-48"
                                  loading="lazy"
                                  src="images/checked_1checked.png"
                                />
                                <div className="text-block-12 welcome selected">
                                  Change Management
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="add_skills">
                            <img
                              alt=""
                              className="image-52"
                              loading="lazy"
                              src="images/plus-1_1plus-1.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="welcome_footer">
                        <div className="dots">
                          <div className="div-block-82"></div>
                          <div className="div-block-82 active"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                        </div>
                        <div className="div-block-81">
                          <div
                            className="g_s_btn-before"
                            data-w-id="9aa50997-bb9c-24ef-8f07-07e00266d9d3"
                          >
                            <div>Previous Step</div>
                          </div>
                          <div className="g_s_btn">
                            <div>Next Step</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p3">
                      <div className="nav">
                        <div className="nav-cont welcome">
                          <div className="nav-left">
                            <img
                              alt=""
                              className="image welcome"
                              loading="lazy"
                              src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="div-block-78">
                        <div className="div-block-84 level_rate">
                          <div className="text-block-62">
                            Now, rate your level
                          </div>
                          <div className="div-block-85">
                            <div className="text-block-63">
                              Event Management
                            </div>
                            <div className="div-block-86">
                              <img
                                alt=""
                                className="image-49"
                                loading="lazy"
                                src="images/invisible_1invisible.png"
                              />
                              <div>Visible only to you</div>
                            </div>
                            <div className="div-block-88">
                              <div className="div-block-87">
                                <div className="step_n">1</div>
                                <div className="step_n">2</div>
                                <div className="step_n">3</div>
                                <div className="step_n">4</div>
                                <div className="step_n">5</div>
                                <div className="step_n">6</div>
                                <div className="step_n">7</div>
                                <div className="step_n">8</div>
                                <div className="step_n">9</div>
                                <div className="step_n">10</div>
                              </div>
                              <div className="fs-rangeslider_form w-form">
                                <form
                                  data-name="Email Form"
                                  data-wf-element-id="47e4e54b-213d-cbb6-63a5-d1d9a2e318e5"
                                  data-wf-page-id="6596e21ac435cac3c66baaee"
                                  id="email-form"
                                  method="get"
                                  name="email-form"
                                >
                                  <div
                                    className="fs-rangeslider_wrapper"
                                    fs-rangeslider-element="wrapper"
                                    fs-rangeslider-formatdisplay="true"
                                    fs-rangeslider-max={90}
                                    fs-rangeslider-min={0}
                                    fs-rangeslider-step={10}
                                  >
                                    <div
                                      className="fs-rangeslider_track"
                                      fs-rangeslider-element="track"
                                    >
                                      <div
                                        className="fs-rangeslider_handle is-pink"
                                        fs-rangeslider-element="handle"
                                      >
                                        <div className="fs-rangeslider_handle-value"></div>
                                      </div>
                                      <div
                                        className="fs-rangeslider_fill"
                                        fs-rangeslider-element="fill"
                                      ></div>
                                    </div>
                                    <input
                                      className="fs-rangeslider_input w-input"
                                      data-name="From 3"
                                      fs-cmsfilter-field="price"
                                      fs-cmsfilter-range="from"
                                      id="From-3"
                                      maxLength={256}
                                      name="From-3"
                                      placeholder="From"
                                      type="text"
                                    />
                                    <div className="fs-range_values hidden"></div>
                                  </div>
                                </form>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                              <div className="div-block-89">
                                <div className="text-block-64">Beginner</div>
                                <div className="text-block-64 mgl">Expert</div>
                              </div>
                              <div className="div-block-90">
                                <img
                                  alt=""
                                  className="image-50"
                                  loading="lazy"
                                  src="images/Screenshot-2022-06-09-at-3.57.09-PM-copy.png"
                                />
                                <div className="text-block-65">
                                  Can complete narrow and limited tasks
                                  requiring basic skills with direct supervision
                                  or guidance.
                                </div>
                                <div className="div-block-91"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="welcome_footer">
                        <div className="dots">
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82 active"></div>
                          <div className="div-block-82"></div>
                        </div>
                        <div className="div-block-81">
                          <div
                            className="g_s_btn-before"
                            data-w-id="9928e986-ed6f-637d-c317-082c6b14b8b9"
                          >
                            <div>Previous Step</div>
                          </div>
                          <div
                            className="g_s_btn-before skip"
                            data-w-id="3eae9302-eb11-698f-76b4-89e59390c401"
                          >
                            <div>Skip Step</div>
                          </div>
                          <div
                            className="g_s_btn r_n"
                            data-w-id="9928e986-ed6f-637d-c317-082c6b14b8bc"
                          >
                            <div>Next Step</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p4">
                      <div className="nav">
                        <div className="nav-cont welcome">
                          <div className="nav-left">
                            <img
                              alt=""
                              className="image welcome"
                              loading="lazy"
                              src="images/629f2930d89dd16507eaaf49_logo-cla-1-copy_1629f2930d89dd16507eaaf49_logo-cla-1-copy.png"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="div-block-78">
                        <div className="div-block-92">
                          <div className="text-block-66">
                            Start Boosting Your Skills!
                          </div>
                          <div className="text-block-67">
                            Check our content selection or manually add more
                            learning items
                          </div>
                          <img
                            alt=""
                            className="image-51"
                            loading="lazy"
                            src="images/4721728.jpg"
                          />
                        </div>
                      </div>
                      <div className="welcome_footer">
                        <div className="dots">
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82"></div>
                          <div className="div-block-82 active"></div>
                        </div>
                        <div className="div-block-81">
                          <div
                            className="g_s_btn-before"
                            data-w-id="b5575d53-82a4-eb35-2e00-06afccc31678"
                          >
                            <div>Previous Step</div>
                          </div>
                          <div className="g_s_btn r_n">
                            <div>Go</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="social_div">
                    <div className="social_cont">
                      <div
                        className="social_box followers"
                        data-name="followers"
                      >
                        <div className="div-block-147">
                          <div>Followers</div>
                          <img
                            alt=""
                            className="image-72"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-148">
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Sara Joyner</div>
                                <div className="text-block-94">
                                  Manual Testing Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Eathan Adam</div>
                                <div className="text-block-94">
                                  Mining Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Maira Paul</div>
                                <div className="text-block-94">
                                  Technical Support Representative
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Nimra Jefferson</div>
                                <div className="text-block-94">
                                  Software Quality Assurance
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Kealan Walters</div>
                                <div className="text-block-94">
                                  Computer Science Professor
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                sizes="(max-width: 479px) 0px, 100vw"
                                src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                              />
                              <div className="div-block-150">
                                <div className="bname">Isobella Simmonds</div>
                                <div className="text-block-94">
                                  Product Manager
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Remove</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="social_box following"
                        data-name="followers"
                      >
                        <div className="div-block-147">
                          <div>Following</div>
                          <img
                            alt=""
                            className="image-72 following"
                            loading="lazy"
                            src="images/close_2close.png"
                          />
                        </div>
                        <div className="div-block-148">
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                sizes="(max-width: 479px) 0px, 100vw"
                                src="images/5eb952f0f5ff0d39622e72e7_c1.jpg"
                                srcset="images/5eb952f0f5ff0d39622e72e7_c1-p-500.jpeg 500w, images/5eb952f0f5ff0d39622e72e7_c1.jpg 700w"
                              />
                              <div className="div-block-150">
                                <div className="bname">Isobella Simmonds</div>
                                <div className="text-block-94">
                                  Product Manager
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Nimra Jefferson</div>
                                <div className="text-block-94">
                                  Software Quality Assurance
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec84145530b12f5abd1e_5f5625e328218db2b3242892_t4-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Eathan Adam</div>
                                <div className="text-block-94">
                                  Mining Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec6101ef995f75468275_5f5625e328218dc96c242881_3.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Maira Paul</div>
                                <div className="text-block-94">
                                  Technical Support Representative
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Sara Joyner</div>
                                <div className="text-block-94">
                                  Manual Testing Engineer
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                          <div className="div-block-149">
                            <a
                              className="link-block-6 w-inline-block"
                              href="https://ibl-skills.webflow.io/public-profile"
                            >
                              <img
                                alt=""
                                className="image-73"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-150">
                                <div className="bname">Kealan Walters</div>
                                <div className="text-block-94">
                                  Computer Science Professor
                                </div>
                              </div>
                            </a>
                            <div className="div-block-151">
                              <div className="text-block-95">Following</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="popup_div nm_popup">
                    <div className="popup_cont sk">
                      <div className="new_message_popup" data-name="followers">
                        <div className="div-block-147 new_msg">
                          <div className="div-block-213">
                            <img
                              alt=""
                              className="cancel_dc c_i"
                              loading="lazy"
                              src="images/close_2close.png"
                            />
                          </div>
                          <div className="text-block-135">New Message</div>
                          <div className="form-btn next_form n_m next disabled">
                            <div className="text-block-136">Next</div>
                          </div>
                        </div>
                        <div className="div-block-214">
                          <div className="form-block s_skill new_msg w-form">
                            <form
                              className="form new_msg"
                              data-name="Email Form"
                              data-wf-element-id="0098f3a5-d7c6-082b-bc6e-3a919de55bbe"
                              data-wf-page-id="6596e21ac435cac3c66baaee"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div className="div-block msg_i">
                                <img
                                  alt=""
                                  className="image-2 s_i"
                                  loading="lazy"
                                  src="images/62d686d8bfd1a30a474161bf_magnifying-glass_162d686d8bfd1a30a474161bf_magnifying-glass.png"
                                />
                              </div>
                              <input
                                className="text-field n_text new_msg w-input"
                                data-name="Email 4"
                                id="email-4"
                                maxLength={256}
                                name="email-4"
                                placeholder="Search People"
                                required=""
                                type="email"
                              />
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="group-users">
                          <div className="f_pfp sel-user-box">
                            <img
                              alt=""
                              className="image-4 feed sel-user"
                              loading="lazy"
                              src="images/t6.jpg"
                            />
                            <div className="div-block-180">
                              <div className="div-block-179 t_r">
                                <div className="text-block-118">Jean Long</div>
                                <img
                                  alt=""
                                  className="cancel_user c_i user_x"
                                  loading="lazy"
                                  src="images/close_2close.png"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="div-block-215 create-group">
                          <div className="div-block-217">
                            <div className="div-block-216">
                              <img
                                alt=""
                                className="image-88"
                                loading="lazy"
                                src="images/people_1people.png"
                              />
                            </div>
                          </div>
                          <div>Create a Group</div>
                        </div>
                        <div className="message_div h_a">
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Jean Long
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @jeanlong{' '}
                                  <span className="text-span-6">•</span> 4m
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Cooper Devlin
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @cooperDevlin{' '}
                                  <span className="text-span-6">•</span> 1h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Annabell Gillespie
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @anabell{' '}
                                  <span className="text-span-6">•</span> 2h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="create_group_popup hidden"
                        data-name="followers"
                      >
                        <div className="div-block-147 new_msg">
                          <div className="div-block-213">
                            <img
                              alt=""
                              className="back_dc c_i"
                              loading="lazy"
                              src="images/arrow_1arrow.png"
                            />
                          </div>
                          <div className="text-block-135">Create a group</div>
                          <div className="form-btn next_form n_m next disabled">
                            <div className="text-block-136">Next</div>
                          </div>
                        </div>
                        <div className="div-block-214">
                          <div className="form-block s_skill new_msg w-form">
                            <form
                              className="form new_msg"
                              data-name="Email Form"
                              data-wf-element-id="9f3b67ad-f339-5eaa-34ec-c44d26d7cec4"
                              data-wf-page-id="6596e21ac435cac3c66baaee"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div className="div-block msg_i">
                                <img
                                  alt=""
                                  className="image-2 s_i"
                                  loading="lazy"
                                  src="images/62d686d8bfd1a30a474161bf_magnifying-glass_162d686d8bfd1a30a474161bf_magnifying-glass.png"
                                />
                              </div>
                              <input
                                className="text-field n_text new_msg w-input"
                                data-name="Email 4"
                                id="email-4"
                                maxLength={256}
                                name="email-4"
                                placeholder="Search People"
                                required=""
                                type="email"
                              />
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="group-users">
                          <div className="f_pfp sel-user-box">
                            <img
                              alt=""
                              className="image-4 feed sel-user"
                              loading="lazy"
                              src="images/t6.jpg"
                            />
                            <div className="div-block-180">
                              <div className="div-block-179 t_r">
                                <div className="text-block-118">Jean Long</div>
                                <img
                                  alt=""
                                  className="cancel_user c_i user_x"
                                  loading="lazy"
                                  src="images/close_2close.png"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="message_div h_a">
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Jean Long
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @jeanlong{' '}
                                  <span className="text-span-6">•</span> 4m
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Cooper Devlin
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @cooperDevlin{' '}
                                  <span className="text-span-6">•</span> 1h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Annabell Gillespie
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @anabell{' '}
                                  <span className="text-span-6">•</span> 2h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="cm_popup_div cm_popup">
                    <div className="popup_cont sk nm">
                      <div className="comment_popup" data-name="followers">
                        <div className="div-block-147 new_msg w_r">
                          <div className="div-block-213">
                            <img
                              alt=""
                              className="cancel_dc c_i comment-c"
                              loading="lazy"
                              src="images/close_2close.png"
                            />
                          </div>
                        </div>
                        <div className="feed-box w_r">
                          <div className="f_pfp w_l">
                            <div className="div-block-229">
                              <img
                                alt=""
                                className="image-4 feed w_i"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-228"></div>
                            </div>
                            <div className="div-block-180">
                              <div className="div-block-179">
                                <div className="text-block-118">Jean Long</div>
                                <div className="text-block-119">
                                  @jeanlong{' '}
                                  <span className="text-span-6">•</span> 1h
                                </div>
                              </div>
                              <div>
                                100 Days of Code: The Complete{' '}
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/Python?src=hashtag_click"
                                >
                                  #Python
                                </a>{' '}
                                Pro{' '}
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/Bootcamp?src=hashtag_click"
                                >
                                  #Bootcamp
                                </a>{' '}
                                for 2022
                                <br />
                                <br />
                                Master{' '}
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/Python?src=hashtag_click"
                                >
                                  #Python
                                </a>{' '}
                                by building 100 projects in 100 days. Learn data
                                science, automation, build websites, games and
                                apps!
                                <br />
                                <br />‍
                                <a
                                  className="tag"
                                  href="https://t.co/2rhmVBeKQ1"
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  https://ibl-skills-v2.webflow.io/course
                                  <br />‍
                                </a>
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/online?src=hashtag_click"
                                >
                                  #online{' '}
                                </a>
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/courses?src=hashtag_click"
                                >
                                  #courses{' '}
                                </a>
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/onlinecourses?src=hashtag_click"
                                >
                                  #onlinecourses{' '}
                                </a>
                                <a
                                  className="tag"
                                  href="https://twitter.com/hashtag/100daysofcode?src=hashtag_click"
                                >
                                  #100daysofcode
                                </a>
                                <a href="https://twitter.com/Sciencenature14/status/1549039384690937864/photo/1">
                                  <br />
                                </a>
                              </div>
                              <div className="text-block-141">
                                Replying to{' '}
                                <a className="tag" href="#">
                                  @jeanlong
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="f_pfp">
                            <img
                              alt=""
                              className="image-4 feed"
                              loading="lazy"
                              src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
                            />
                            <div className="div-block-180">
                              <div className="form-block-6 w-form">
                                <form
                                  data-name="Email Form 2"
                                  data-wf-element-id="73b8eb22-3b88-0089-07e1-e2e71a25b337"
                                  data-wf-page-id="6596e21ac435cac3c66baaee"
                                  id="email-form-2"
                                  method="get"
                                  name="email-form-2"
                                >
                                  <textarea
                                    className="textarea w-input"
                                    data-name="field"
                                    defaultvalue={''}
                                    id="field"
                                    maxLength={5000}
                                    name="field"
                                    placeholder="Post your reply"
                                  ></textarea>
                                </form>
                                <div className="div-block-185">
                                  <div className="div-block-184">
                                    <div className="div-block-183">
                                      <div className="c_icon tw-img-trigger">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/image-1_1image-1.png"
                                        />
                                      </div>
                                      <div className="media-upload">
                                        <div className="html-embed-6 w-embed">
                                          <form action="">
                                            <input
                                              accept="image/png, image/gif, image/jpeg"
                                              id="tw-img-uploader"
                                              name="twIMG"
                                              type="file"
                                            />
                                          </form>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="div-block-183">
                                      <div className="c_icon">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/gif-file.png"
                                        />
                                      </div>
                                    </div>
                                    <div className="div-block-183 mob_h">
                                      <div className="c_icon">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/poll_1poll.png"
                                        />
                                      </div>
                                    </div>
                                    <div className="div-block-183">
                                      <div className="c_icon">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/happy_1happy.png"
                                        />
                                      </div>
                                    </div>
                                    <div className="div-block-183 mob_h">
                                      <div className="c_icon">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/calendar_1calendar.png"
                                        />
                                      </div>
                                    </div>
                                    <div className="div-block-183">
                                      <div className="c_icon">
                                        <img
                                          alt=""
                                          className="f-i sm"
                                          loading="lazy"
                                          src="images/location_1location.png"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="div-block-186">
                                    <div>Post</div>
                                  </div>
                                </div>
                                <div className="w-form-done">
                                  <div>
                                    Thank you! Your submission has been
                                    received!
                                  </div>
                                </div>
                                <div className="w-form-fail">
                                  <div>
                                    Oops! Something went wrong while submitting
                                    the form.
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="create_group_popup hidden"
                        data-name="followers"
                      >
                        <div className="div-block-147 new_msg">
                          <div className="div-block-213">
                            <img
                              alt=""
                              className="back_dc c_i"
                              loading="lazy"
                              src="images/arrow_1arrow.png"
                            />
                          </div>
                          <div className="text-block-135">Create a group</div>
                          <div className="form-btn next_form n_m next disabled">
                            <div className="text-block-136">Next</div>
                          </div>
                        </div>
                        <div className="div-block-214">
                          <div className="form-block s_skill new_msg w-form">
                            <form
                              className="form new_msg"
                              data-name="Email Form"
                              data-wf-element-id="c0c25d2b-8fac-950b-58ae-4e1df5d57756"
                              data-wf-page-id="6596e21ac435cac3c66baaee"
                              id="email-form"
                              method="get"
                              name="email-form"
                            >
                              <div className="div-block msg_i">
                                <img
                                  alt=""
                                  className="image-2 s_i"
                                  loading="lazy"
                                  src="images/62d686d8bfd1a30a474161bf_magnifying-glass_162d686d8bfd1a30a474161bf_magnifying-glass.png"
                                />
                              </div>
                              <input
                                className="text-field n_text new_msg w-input"
                                data-name="Email 4"
                                id="email-4"
                                maxLength={256}
                                name="email-4"
                                placeholder="Search People"
                                required=""
                                type="email"
                              />
                            </form>
                            <div className="w-form-done">
                              <div>
                                Thank you! Your submission has been received!
                              </div>
                            </div>
                            <div className="w-form-fail">
                              <div>
                                Oops! Something went wrong while submitting the
                                form.
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="group-users">
                          <div className="f_pfp sel-user-box">
                            <img
                              alt=""
                              className="image-4 feed sel-user"
                              loading="lazy"
                              src="images/t6.jpg"
                            />
                            <div className="div-block-180">
                              <div className="div-block-179 t_r">
                                <div className="text-block-118">Jean Long</div>
                                <img
                                  alt=""
                                  className="cancel_user c_i user_x"
                                  loading="lazy"
                                  src="images/close_2close.png"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="message_div h_a">
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/t6.jpg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Jean Long
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @jeanlong{' '}
                                  <span className="text-span-6">•</span> 4m
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec3ab27958e500de411b_5f5625e328218d67b6242873_t2-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Cooper Devlin
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @cooperDevlin{' '}
                                  <span className="text-span-6">•</span> 1h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                          <div className="tw_r new_m_user">
                            <div className="f_pfp">
                              <img
                                alt=""
                                className="image-4 feed"
                                loading="lazy"
                                src="images/60f6ec104e702cd2e72aabf0_5f5625e328218de5e4242883_t1-1.jpeg"
                              />
                              <div className="div-block-180">
                                <div className="div-block-179 t_r">
                                  <div className="text-block-118">
                                    Annabell Gillespie
                                  </div>
                                </div>
                                <div className="text-block-119">
                                  @anabell{' '}
                                  <span className="text-span-6">•</span> 2h
                                </div>
                              </div>
                            </div>
                            <img
                              alt=""
                              className="cancel_dc c_i user_tick"
                              loading="lazy"
                              src="images/check-7_1check-7.png"
                              width={13}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer></Footer>
                </div>
              </div>
              <Copilot></Copilot>
            </div>
          </div>
        </span>
      </span>
    );
  }
}

export default SocialView;

/* eslint-enable */
